(function () {
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2ebca2d23ae8704c$var$t = globalThis, $2ebca2d23ae8704c$export$b4d10f6001c083c2 = $2ebca2d23ae8704c$var$t.ShadowRoot && (void 0 === $2ebca2d23ae8704c$var$t.ShadyCSS || $2ebca2d23ae8704c$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $2ebca2d23ae8704c$var$s = Symbol(), $2ebca2d23ae8704c$var$o = new WeakMap;
class $2ebca2d23ae8704c$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $2ebca2d23ae8704c$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($2ebca2d23ae8704c$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $2ebca2d23ae8704c$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $2ebca2d23ae8704c$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $2ebca2d23ae8704c$export$8d80f9cac07cdb3 = (t)=>new $2ebca2d23ae8704c$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $2ebca2d23ae8704c$var$s), $2ebca2d23ae8704c$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $2ebca2d23ae8704c$export$505d1e8739bad805(o, t, $2ebca2d23ae8704c$var$s);
}, $2ebca2d23ae8704c$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($2ebca2d23ae8704c$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $2ebca2d23ae8704c$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $2ebca2d23ae8704c$export$ee69dfd951e24778 = $2ebca2d23ae8704c$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $2ebca2d23ae8704c$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $85ef972dd7b092e7$var$i, defineProperty: $85ef972dd7b092e7$var$e, getOwnPropertyDescriptor: $85ef972dd7b092e7$var$h, getOwnPropertyNames: $85ef972dd7b092e7$var$r, getOwnPropertySymbols: $85ef972dd7b092e7$var$o, getPrototypeOf: $85ef972dd7b092e7$var$n } = Object, $85ef972dd7b092e7$var$a = globalThis, $85ef972dd7b092e7$var$c = $85ef972dd7b092e7$var$a.trustedTypes, $85ef972dd7b092e7$var$l = $85ef972dd7b092e7$var$c ? $85ef972dd7b092e7$var$c.emptyScript : "", $85ef972dd7b092e7$var$p = $85ef972dd7b092e7$var$a.reactiveElementPolyfillSupport, $85ef972dd7b092e7$var$d = (t, s)=>t, $85ef972dd7b092e7$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $85ef972dd7b092e7$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $85ef972dd7b092e7$export$53a6892c50694894 = (t, s)=>!$85ef972dd7b092e7$var$i(t, s), $85ef972dd7b092e7$var$b = {
    attribute: !0,
    type: String,
    converter: $85ef972dd7b092e7$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $85ef972dd7b092e7$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $85ef972dd7b092e7$var$a.litPropertyMetadata ??= new WeakMap;
class $85ef972dd7b092e7$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $85ef972dd7b092e7$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $85ef972dd7b092e7$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $85ef972dd7b092e7$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $85ef972dd7b092e7$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($85ef972dd7b092e7$var$d("elementProperties"))) return;
        const t = $85ef972dd7b092e7$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($85ef972dd7b092e7$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($85ef972dd7b092e7$var$d("properties"))) {
            const t = this.properties, s = [
                ...$85ef972dd7b092e7$var$r(t),
                ...$85ef972dd7b092e7$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $2ebca2d23ae8704c$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $2ebca2d23ae8704c$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $2ebca2d23ae8704c$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $85ef972dd7b092e7$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $85ef972dd7b092e7$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, h) {
        if (void 0 !== t) {
            const r = this.constructor;
            if (!1 === e && (h = this[t]), i ??= r.getPropertyOptions(t), !((i.hasChanged ?? $85ef972dd7b092e7$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(r._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$85ef972dd7b092e7$export$c7c07a37856565d.elementStyles = [], $85ef972dd7b092e7$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $85ef972dd7b092e7$export$c7c07a37856565d[$85ef972dd7b092e7$var$d("elementProperties")] = new Map, $85ef972dd7b092e7$export$c7c07a37856565d[$85ef972dd7b092e7$var$d("finalized")] = new Map, $85ef972dd7b092e7$var$p?.({
    ReactiveElement: $85ef972dd7b092e7$export$c7c07a37856565d
}), ($85ef972dd7b092e7$var$a.reactiveElementVersions ??= []).push("2.1.2");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $bd6886d5707a45a8$var$t = globalThis, $bd6886d5707a45a8$var$i = (t)=>t, $bd6886d5707a45a8$var$s = $bd6886d5707a45a8$var$t.trustedTypes, $bd6886d5707a45a8$var$e = $bd6886d5707a45a8$var$s ? $bd6886d5707a45a8$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $bd6886d5707a45a8$var$h = "$lit$", $bd6886d5707a45a8$var$o = `lit$${Math.random().toFixed(9).slice(2)}$`, $bd6886d5707a45a8$var$n = "?" + $bd6886d5707a45a8$var$o, $bd6886d5707a45a8$var$r = `<${$bd6886d5707a45a8$var$n}>`, $bd6886d5707a45a8$var$l = document, $bd6886d5707a45a8$var$c = ()=>$bd6886d5707a45a8$var$l.createComment(""), $bd6886d5707a45a8$var$a = (t)=>null === t || "object" != typeof t && "function" != typeof t, $bd6886d5707a45a8$var$u = Array.isArray, $bd6886d5707a45a8$var$d = (t)=>$bd6886d5707a45a8$var$u(t) || "function" == typeof t?.[Symbol.iterator], $bd6886d5707a45a8$var$f = "[ \t\n\f\r]", $bd6886d5707a45a8$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $bd6886d5707a45a8$var$_ = /-->/g, $bd6886d5707a45a8$var$m = />/g, $bd6886d5707a45a8$var$p = RegExp(`>|${$bd6886d5707a45a8$var$f}(?:([^\\s"'>=/]+)(${$bd6886d5707a45a8$var$f}*=${$bd6886d5707a45a8$var$f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $bd6886d5707a45a8$var$g = /'/g, $bd6886d5707a45a8$var$$ = /"/g, $bd6886d5707a45a8$var$y = /^(?:script|style|textarea|title)$/i, $bd6886d5707a45a8$var$x = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $bd6886d5707a45a8$export$c0bb0b647f701bb5 = $bd6886d5707a45a8$var$x(1), $bd6886d5707a45a8$export$7ed1367e7fa1ad68 = $bd6886d5707a45a8$var$x(2), $bd6886d5707a45a8$export$47d5b44d225be5b4 = $bd6886d5707a45a8$var$x(3), $bd6886d5707a45a8$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $bd6886d5707a45a8$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $bd6886d5707a45a8$var$C = new WeakMap, $bd6886d5707a45a8$var$P = $bd6886d5707a45a8$var$l.createTreeWalker($bd6886d5707a45a8$var$l, 129);
function $bd6886d5707a45a8$var$V(t, i) {
    if (!$bd6886d5707a45a8$var$u(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $bd6886d5707a45a8$var$e ? $bd6886d5707a45a8$var$e.createHTML(i) : i;
}
const $bd6886d5707a45a8$var$N = (t, i)=>{
    const s = t.length - 1, e = [];
    let n, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $bd6886d5707a45a8$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, f = 0;
        for(; f < s.length && (c.lastIndex = f, u = c.exec(s), null !== u);)f = c.lastIndex, c === $bd6886d5707a45a8$var$v ? "!--" === u[1] ? c = $bd6886d5707a45a8$var$_ : void 0 !== u[1] ? c = $bd6886d5707a45a8$var$m : void 0 !== u[2] ? ($bd6886d5707a45a8$var$y.test(u[2]) && (n = RegExp("</" + u[2], "g")), c = $bd6886d5707a45a8$var$p) : void 0 !== u[3] && (c = $bd6886d5707a45a8$var$p) : c === $bd6886d5707a45a8$var$p ? ">" === u[0] ? (c = n ?? $bd6886d5707a45a8$var$v, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $bd6886d5707a45a8$var$p : '"' === u[3] ? $bd6886d5707a45a8$var$$ : $bd6886d5707a45a8$var$g) : c === $bd6886d5707a45a8$var$$ || c === $bd6886d5707a45a8$var$g ? c = $bd6886d5707a45a8$var$p : c === $bd6886d5707a45a8$var$_ || c === $bd6886d5707a45a8$var$m ? c = $bd6886d5707a45a8$var$v : (c = $bd6886d5707a45a8$var$p, n = void 0);
        const x = c === $bd6886d5707a45a8$var$p && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $bd6886d5707a45a8$var$v ? s + $bd6886d5707a45a8$var$r : d >= 0 ? (e.push(a), s.slice(0, d) + $bd6886d5707a45a8$var$h + s.slice(d) + $bd6886d5707a45a8$var$o + x) : s + $bd6886d5707a45a8$var$o + (-2 === d ? i : x);
    }
    return [
        $bd6886d5707a45a8$var$V(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $bd6886d5707a45a8$var$S {
    constructor({ strings: t, _$litType$: i }, e){
        let r;
        this.parts = [];
        let l = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $bd6886d5707a45a8$var$N(t, i);
        if (this.el = $bd6886d5707a45a8$var$S.createElement(f, e), $bd6886d5707a45a8$var$P.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $bd6886d5707a45a8$var$P.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($bd6886d5707a45a8$var$h)) {
                    const i = v[a++], s = r.getAttribute(t).split($bd6886d5707a45a8$var$o), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: l,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $bd6886d5707a45a8$var$I : "?" === e[1] ? $bd6886d5707a45a8$var$L : "@" === e[1] ? $bd6886d5707a45a8$var$z : $bd6886d5707a45a8$var$H
                    }), r.removeAttribute(t);
                } else t.startsWith($bd6886d5707a45a8$var$o) && (d.push({
                    type: 6,
                    index: l
                }), r.removeAttribute(t));
                if ($bd6886d5707a45a8$var$y.test(r.tagName)) {
                    const t = r.textContent.split($bd6886d5707a45a8$var$o), i = t.length - 1;
                    if (i > 0) {
                        r.textContent = $bd6886d5707a45a8$var$s ? $bd6886d5707a45a8$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)r.append(t[s], $bd6886d5707a45a8$var$c()), $bd6886d5707a45a8$var$P.nextNode(), d.push({
                            type: 2,
                            index: ++l
                        });
                        r.append(t[i], $bd6886d5707a45a8$var$c());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $bd6886d5707a45a8$var$n) d.push({
                    type: 2,
                    index: l
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($bd6886d5707a45a8$var$o, t + 1));)d.push({
                        type: 7,
                        index: l
                    }), t += $bd6886d5707a45a8$var$o.length - 1;
                }
            }
            l++;
        }
    }
    static createElement(t, i) {
        const s = $bd6886d5707a45a8$var$l.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $bd6886d5707a45a8$var$M(t, i, s = t, e) {
    if (i === $bd6886d5707a45a8$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $bd6886d5707a45a8$var$a(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $bd6886d5707a45a8$var$M(t, h._$AS(t, i.values), h, e)), i;
}
class $bd6886d5707a45a8$var$R {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $bd6886d5707a45a8$var$l).importNode(i, !0);
        $bd6886d5707a45a8$var$P.currentNode = e;
        let h = $bd6886d5707a45a8$var$P.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $bd6886d5707a45a8$var$k(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $bd6886d5707a45a8$var$Z(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $bd6886d5707a45a8$var$P.nextNode(), o++);
        }
        return $bd6886d5707a45a8$var$P.currentNode = $bd6886d5707a45a8$var$l, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $bd6886d5707a45a8$var$k {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $bd6886d5707a45a8$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $bd6886d5707a45a8$var$M(this, t, i), $bd6886d5707a45a8$var$a(t) ? t === $bd6886d5707a45a8$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $bd6886d5707a45a8$export$45b790e32b2810ee && this._$AR(), this._$AH = $bd6886d5707a45a8$export$45b790e32b2810ee) : t !== this._$AH && t !== $bd6886d5707a45a8$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $bd6886d5707a45a8$var$d(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $bd6886d5707a45a8$export$45b790e32b2810ee && $bd6886d5707a45a8$var$a(this._$AH) ? this._$AA.nextSibling.data = t : this.T($bd6886d5707a45a8$var$l.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $bd6886d5707a45a8$var$S.createElement($bd6886d5707a45a8$var$V(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $bd6886d5707a45a8$var$R(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $bd6886d5707a45a8$var$C.get(t.strings);
        return void 0 === i && $bd6886d5707a45a8$var$C.set(t.strings, i = new $bd6886d5707a45a8$var$S(t)), i;
    }
    k(t) {
        $bd6886d5707a45a8$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $bd6886d5707a45a8$var$k(this.O($bd6886d5707a45a8$var$c()), this.O($bd6886d5707a45a8$var$c()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, s) {
        for(this._$AP?.(!1, !0, s); t !== this._$AB;){
            const s = $bd6886d5707a45a8$var$i(t).nextSibling;
            $bd6886d5707a45a8$var$i(t).remove(), t = s;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $bd6886d5707a45a8$var$H {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $bd6886d5707a45a8$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $bd6886d5707a45a8$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $bd6886d5707a45a8$var$M(this, t, i, 0), o = !$bd6886d5707a45a8$var$a(t) || t !== this._$AH && t !== $bd6886d5707a45a8$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $bd6886d5707a45a8$var$M(this, e[s + n], i, n), r === $bd6886d5707a45a8$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$bd6886d5707a45a8$var$a(r) || r !== this._$AH[n], r === $bd6886d5707a45a8$export$45b790e32b2810ee ? t = $bd6886d5707a45a8$export$45b790e32b2810ee : t !== $bd6886d5707a45a8$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $bd6886d5707a45a8$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $bd6886d5707a45a8$var$I extends $bd6886d5707a45a8$var$H {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $bd6886d5707a45a8$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $bd6886d5707a45a8$var$L extends $bd6886d5707a45a8$var$H {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $bd6886d5707a45a8$export$45b790e32b2810ee);
    }
}
class $bd6886d5707a45a8$var$z extends $bd6886d5707a45a8$var$H {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $bd6886d5707a45a8$var$M(this, t, i, 0) ?? $bd6886d5707a45a8$export$45b790e32b2810ee) === $bd6886d5707a45a8$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $bd6886d5707a45a8$export$45b790e32b2810ee && s !== $bd6886d5707a45a8$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $bd6886d5707a45a8$export$45b790e32b2810ee && (s === $bd6886d5707a45a8$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $bd6886d5707a45a8$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $bd6886d5707a45a8$var$M(this, t);
    }
}
const $bd6886d5707a45a8$export$8613d1ca9052b22e = {
    M: $bd6886d5707a45a8$var$h,
    P: $bd6886d5707a45a8$var$o,
    A: $bd6886d5707a45a8$var$n,
    C: 1,
    L: $bd6886d5707a45a8$var$N,
    R: $bd6886d5707a45a8$var$R,
    D: $bd6886d5707a45a8$var$d,
    V: $bd6886d5707a45a8$var$M,
    I: $bd6886d5707a45a8$var$k,
    H: $bd6886d5707a45a8$var$H,
    N: $bd6886d5707a45a8$var$L,
    U: $bd6886d5707a45a8$var$z,
    B: $bd6886d5707a45a8$var$I,
    F: $bd6886d5707a45a8$var$Z
}, $bd6886d5707a45a8$var$B = $bd6886d5707a45a8$var$t.litHtmlPolyfillSupport;
$bd6886d5707a45a8$var$B?.($bd6886d5707a45a8$var$S, $bd6886d5707a45a8$var$k), ($bd6886d5707a45a8$var$t.litHtmlVersions ??= []).push("3.3.2");
const $bd6886d5707a45a8$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $bd6886d5707a45a8$var$k(i.insertBefore($bd6886d5707a45a8$var$c(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $baeea1393dcde116$var$s = globalThis;
class $baeea1393dcde116$export$3f2f9f5909897157 extends (0, $85ef972dd7b092e7$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $bd6886d5707a45a8$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $bd6886d5707a45a8$export$9c068ae9cc5db4e8;
    }
}
$baeea1393dcde116$export$3f2f9f5909897157._$litElement$ = !0, $baeea1393dcde116$export$3f2f9f5909897157["finalized"] = !0, $baeea1393dcde116$var$s.litElementHydrateSupport?.({
    LitElement: $baeea1393dcde116$export$3f2f9f5909897157
});
const $baeea1393dcde116$var$o = $baeea1393dcde116$var$s.litElementPolyfillSupport;
$baeea1393dcde116$var$o?.({
    LitElement: $baeea1393dcde116$export$3f2f9f5909897157
});
const $baeea1393dcde116$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($baeea1393dcde116$var$s.litElementVersions ??= []).push("4.2.2");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b9804ca6181681c9$export$6acf61af03e62db = !1;





const $11c5d80616107844$export$fe8bb99ae811cfd6 = (0, $2ebca2d23ae8704c$export$dbf350e5966cf602)`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

:host(:not([selected])) {
  display: none;
}

:host([selected]) {
  border-top: 1px solid var(--bctab-border-color);
  flex-basis: 100%;
  padding: 20px;
  display: block;
}
`;



const $27bbcb5d8995a93c$export$734f668c87ead58f = (0, $2ebca2d23ae8704c$export$dbf350e5966cf602)`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

:host, slot {
  margin-top: var(--bctabs-offset-top, 0);
  flex-wrap: wrap;
  width: 100%;
  display: flex;
}

@media screen and (width >= 47em), print {
  .c-tabbar {
    column-gap: var(--spacing--);
    padding-inline: 20px;
    display: inline-flex;
  }
}

@media screen and (width <= 46.9375em) {
  .c-tabbar {
    flex: 1;
    column-gap: 2px;
    padding-inline: 13px;
    display: flex;
  }
}
`;


/**
 * Basis tool voor het afhandelen van async communicatie. Hier is eventueel nog een standaard error afhandeling tussen te hangen.
 */ /**
 * Fetches data from the given URL using a GET request.
 *
 * @async
 * @function getUrl
 * @param {string} url - The URL to fetch data from.
 * @returns {Promise<{status: number, data: any}>} The response status and data.
 */ const $80b8792c09f43040$var$getUrl = async (url)=>{
    const options = {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8"
        }
    };
    let response = await fetch(url, options);
    let status = response.status;
    let data = await response.json();
    return {
        status: status,
        data: data
    };
};
/**
 * Sends data to the given URL using a POST request.
 *
 * @async
 * @function postUrl
 * @param {string} url - The URL to send data to.
 * @param {Object} postData - The data to send in the body of the POST request.
 * @returns {Promise<{status: number, data: any}>} The response status and data.
 */ const $80b8792c09f43040$var$postUrl = async (url, postData)=>{
    const options = {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
            "Cache-Control": "no-cache, no-store, must-revalidate",
            Pragma: "no-cache"
        },
        body: JSON.stringify(postData)
    };
    let response = await fetch(url, options);
    let status = response.status;
    let data = null;
    try {
        data = await response?.json();
    } catch (error) {}
    return {
        status: status,
        data: data
    };
};
const $80b8792c09f43040$export$f8a0a232efd61230 = ()=>{
    return {
        getUrl: $80b8792c09f43040$var$getUrl,
        postUrl: $80b8792c09f43040$var$postUrl
    };
};


function $7a3728ce0eeb1492$var$partMap(parts) {
    return Object.entries(parts).filter(([key, value])=>value).map(([key, value])=>key).join(" ");
}
class $7a3728ce0eeb1492$var$Tabs extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    static get properties() {
        return {
            defaultTab: {
                type: Number,
                attribute: "data-default-tab"
            },
            isClosable: {
                type: Boolean,
                attribute: "data-is-closable",
                reflect: true
            },
            tooltip: {
                type: String,
                reflect: true,
                state: true
            }
        };
    }
    constructor(){
        super();
    }
    get tabs() {
        const slot = this.shadowRoot.querySelector("slot");
        return slot ? slot.assignedElements() : [];
    }
    selectTab(clickedTab) {
        let usageWidget;
        if ((usageWidget = document.querySelector(".js-usage-widget")) && clickedTab.switchInput) {
            var isGas = clickedTab.switchInput == "gas";
            usageWidget.toggleAttribute("data-show-gas", isGas);
            document.getElementById("hiddenType").value = isGas ? "gas" : "strom";
            document.getElementById("hiddenProductType").value = isGas ? "gas" : "electricity";
            document.getElementById("hiddenEnergyArea").value = isGas ? "gas" : "Electricity";
            var currentAction = document.querySelector(".js-input-widget").getAttribute("action");
            var newAction = isGas ? currentAction.replace("strom", "gas") : currentAction.replace("gas", "strom");
            document.querySelector(".js-input-widget").setAttribute("action", newAction);
        }
        if (clickedTab && clickedTab.selected == true && this.isClosable) clickedTab.selected = false;
        else for (let tab of this.tabs)tab.selected = tab == clickedTab;
        this.requestUpdate();
    }
    firstUpdated() {
        super.firstUpdated();
        this.tabs.find((tab)=>tab.selected) || this.selectTab(this.tabs[this.defaultTab]);
    }
    render() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
      <nav part="tab-bar" class="c-tabbar">
        ${this.tabs.map((tab, index)=>(0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
            <span part=${$7a3728ce0eeb1492$var$partMap({
                tab: true,
                "tab-selected": tab.selected,
                [`tab-index-${index + 1}`]: true
            })} data-index="${index + 1}" class="${tab.selected ? "tab-selected" : ""}" @click=${(ev)=>this.selectTab(tab)}> ${tab.title} </span>
            ${tab.tooltip ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<bc-tooltip data-trigger-style="none">${tab.tooltip}</bc-tooltip>` : ""}
          `)}
      </nav>

      <slot part="content" @slotchange=${(ev)=>this.requestUpdate()}></slot>
    `;
    }
}
$7a3728ce0eeb1492$var$Tabs.styles = [
    (0, $27bbcb5d8995a93c$export$734f668c87ead58f)
];
class $7a3728ce0eeb1492$var$Tab extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    static get properties() {
        return {
            title: {
                type: String,
                attribute: "data-tab-title"
            },
            content: {
                type: String,
                reflect: true
            },
            detailUrl: {
                type: String,
                reflect: true
            },
            detailPostUrl: {
                type: String,
                reflect: true
            },
            detailPostData: {
                type: String,
                reflect: true
            },
            waitingForData: {
                type: Boolean,
                state: true
            },
            isAsync: {
                type: Boolean,
                attribute: "data-is-async"
            },
            selected: {
                type: Boolean,
                reflect: true
            },
            switchInput: {
                type: String,
                attribute: "data-switch-input",
                reflect: true
            }
        };
    }
    constructor(){
        super();
        this.waitingForData = this.detailUrl || this.detailPostUrl == undefined ? true : false;
    }
    async updated(changedProperties) {
        if (changedProperties.has("selected") && this.selected && this.isAsync) {
            const asyncHelper = (0, $80b8792c09f43040$export$f8a0a232efd61230)();
            let { data: data, status: status } = {};
            if (this.detailUrl) ({ data: data, status: status } = await asyncHelper.getUrl(this.detailUrl));
            else {
                let postData = JSON.parse(this.detailPostData);
                ({ data: data, status: status } = await asyncHelper.postUrl(this.detailPostUrl, postData));
            }
            this.waitingForData = false;
            if (status == 200) {
                const options = {
                    detail: {
                        data: data
                    },
                    bubbles: true,
                    composed: true
                };
                this.dispatchEvent(new CustomEvent("data-fetched", options));
            } else throw new Error(`Failed to fetch data from ${this.detailUrl || this.detailPostUrl}`);
        }
    }
    render() {
        if (!this.isAsync) this.waitingForData = false;
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` ${this.waitingForData ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<bc-loading-icon data-inline="true"></bc-loading-icon>` : (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<slot>${this.content}</slot>`} `;
    }
}
$7a3728ce0eeb1492$var$Tab.styles = [
    (0, $11c5d80616107844$export$fe8bb99ae811cfd6)
];
const $7a3728ce0eeb1492$export$a7bf4f2a9a5bdf95 = ()=>{
    if (!window.customElements.get("bc-tab")) customElements.define("bc-tab", $7a3728ce0eeb1492$var$Tab);
    if (!window.customElements.get("bc-tabs")) customElements.define("bc-tabs", $7a3728ce0eeb1492$var$Tabs);
};




const $42f4265c0ce36ff0$export$da69cd37b7514c47 = (0, $2ebca2d23ae8704c$export$dbf350e5966cf602)`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

:host {
  z-index: 50;
  background: var(--color-white);
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  color: var(--color-grey--dark);
  box-shadow: 0 10px 35px 0 hsl(from var(--color-black) h s l / .35);
  border-radius: var(--border-radius-s);
  opacity: 0;
  min-width: 320px;
  max-width: min(400px, 100vw - 30px);
  animation-name: tooltipHide;
  animation-duration: 0s;
  animation-fill-mode: forwards;
  animation-timing-function: var(----swift-ease-in-out);
  padding: 20px;
  font-weight: 400;
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  transform: scale(.75);
}

:host([showing]) {
  opacity: 1;
  animation-name: tooltipShow;
  animation-duration: .3s;
  animation-fill-mode: forwards;
  display: block;
  transform: scale(1);
}

@keyframes tooltipShow {
  from {
    opacity: 0;
    transform: scale(.75);
  }
}

@keyframes tooltipHide {
  from {
    opacity: 1;
    display: block;
    transform: scale(1);
  }
}

.tooltip-arrow {
  border-width: 0 20px 20px;
  border-color: transparent transparent var(--color-white) transparent;
  border-style: solid;
  width: 0;
  height: 0;
  position: absolute;
}

.tooltip-arrow.on-bottom {
  top: -10px;
  transform: rotate(0);
}

.tooltip-arrow.on-top {
  bottom: -10px;
  transform: rotate(180deg);
}

.tooltip-arrow.on-right {
  left: -20px;
  transform: rotate(-90deg);
}

.tooltip-arrow.on-left {
  right: -20px;
  transform: rotate(90deg);
}

@media screen and (width >= 75em), print {
  .c-icon-close-tooltip {
    display: none;
  }
}

@media screen and (width <= 74.9375em) {
  .c-icon-close-tooltip {
    border-radius: var(--border-radius-s);
    background-color: var(--color-grey--x-light);
    float: right;
    cursor: pointer;
    z-index: 60;
    width: 32px;
    height: 32px;
    margin-top: -7px;
    margin-left: 4px;
    position: relative;
  }

  .c-icon-close-tooltip:hover {
    background-color: var(--color-brand--support);
  }

  .c-icon-close-tooltip:hover:before, .c-icon-close-tooltip:hover:after {
    background-color: var(--color-white);
  }

  .c-icon-close-tooltip:before, .c-icon-close-tooltip:after {
    content: "";
    background-color: var(--color-brand--support);
    position: absolute;
  }

  .c-icon-close-tooltip:before {
    transform-origin: center;
    height: 2px;
    top: 50%;
    left: 0;
    right: 0;
    transform: rotate(45deg) scale(.5);
  }

  .c-icon-close-tooltip:after {
    transform-origin: center;
    height: 2px;
    top: 50%;
    left: 0;
    right: 0;
    transform: rotate(-45deg) scale(.5);
  }
}
`;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0353fc6f6191f088$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ef3825aa571d12b8$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $85ef972dd7b092e7$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $85ef972dd7b092e7$export$53a6892c50694894)
}, $ef3825aa571d12b8$export$8d623b1670eb40f4 = (t = $ef3825aa571d12b8$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), "setter" === n && ((t = Object.create(t)).wrapped = !0), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t, !0, r);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t, e), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t, !0, r);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $ef3825aa571d12b8$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $ef3825aa571d12b8$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $b05956b34e6c1b48$export$ca000e230c0caa3e(r) {
    return (0, $ef3825aa571d12b8$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $564781e56cb55bfd$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e52507cec9dfd9a5$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9dde40d50caa9c07$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $e52507cec9dfd9a5$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $e52507cec9dfd9a5$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $b13433a6c55f6826$var$e;
function $b13433a6c55f6826$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $e52507cec9dfd9a5$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($b13433a6c55f6826$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $0486aebddf3ac8a1$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $e52507cec9dfd9a5$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c9692ea61d3cb784$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $e52507cec9dfd9a5$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $476aa140762dd8be$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $e52507cec9dfd9a5$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cc5562de03e1a67c$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $cc5562de03e1a67c$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $cc5562de03e1a67c$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}




/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $680df362cb03773e$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $680df362cb03773e$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $680df362cb03773e$export$803cd8101b6c182b = /*#__PURE__*/ $680df362cb03773e$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $680df362cb03773e$export$27b07d8a310ed8b5[0], side + "-" + $680df362cb03773e$export$27b07d8a310ed8b5[1]), []);
const $680df362cb03773e$export$96ec731ed4dcb222 = Math.min;
const $680df362cb03773e$export$8960430cfd85939f = Math.max;
const $680df362cb03773e$export$2077e0241d6afd3c = Math.round;
const $680df362cb03773e$export$a3fe094919f356fd = Math.floor;
const $680df362cb03773e$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $680df362cb03773e$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $680df362cb03773e$export$7d15b64cf5a3a4c4(start, value, end) {
    return $680df362cb03773e$export$8960430cfd85939f(start, $680df362cb03773e$export$96ec731ed4dcb222(value, end));
}
function $680df362cb03773e$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $680df362cb03773e$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $680df362cb03773e$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $680df362cb03773e$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $680df362cb03773e$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $680df362cb03773e$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $680df362cb03773e$export$2b57e0052a6d6d4c(placement) {
    return $680df362cb03773e$export$8a000a963141ac32($680df362cb03773e$export$f28e8f882010718a(placement));
}
function $680df362cb03773e$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $680df362cb03773e$export$f0989780f32bfcda(placement);
    const alignmentAxis = $680df362cb03773e$export$2b57e0052a6d6d4c(placement);
    const length = $680df362cb03773e$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $680df362cb03773e$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $680df362cb03773e$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $680df362cb03773e$export$496432a3699e50b1(placement) {
    const oppositePlacement = $680df362cb03773e$export$9c5e28bad23365fa(placement);
    return [
        $680df362cb03773e$export$2b182c584985588b(placement),
        oppositePlacement,
        $680df362cb03773e$export$2b182c584985588b(oppositePlacement)
    ];
}
function $680df362cb03773e$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $680df362cb03773e$var$lrPlacement = [
    'left',
    'right'
];
const $680df362cb03773e$var$rlPlacement = [
    'right',
    'left'
];
const $680df362cb03773e$var$tbPlacement = [
    'top',
    'bottom'
];
const $680df362cb03773e$var$btPlacement = [
    'bottom',
    'top'
];
function $680df362cb03773e$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $680df362cb03773e$var$rlPlacement : $680df362cb03773e$var$lrPlacement;
            return isStart ? $680df362cb03773e$var$lrPlacement : $680df362cb03773e$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $680df362cb03773e$var$tbPlacement : $680df362cb03773e$var$btPlacement;
        default:
            return [];
    }
}
function $680df362cb03773e$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $680df362cb03773e$export$f0989780f32bfcda(placement);
    let list = $680df362cb03773e$var$getSideList($680df362cb03773e$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($680df362cb03773e$export$2b182c584985588b));
    }
    return list;
}
function $680df362cb03773e$export$9c5e28bad23365fa(placement) {
    const side = $680df362cb03773e$export$3c915306cb7fc97a(placement);
    return $680df362cb03773e$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $680df362cb03773e$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $680df362cb03773e$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $680df362cb03773e$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $680df362cb03773e$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $3d1fb7771a650d07$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $680df362cb03773e$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $680df362cb03773e$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $680df362cb03773e$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $680df362cb03773e$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $680df362cb03773e$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $3d1fb7771a650d07$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $680df362cb03773e$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $680df362cb03773e$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $680df362cb03773e$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $680df362cb03773e$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $3d1fb7771a650d07$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $3d1fb7771a650d07$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $3d1fb7771a650d07$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $3d1fb7771a650d07$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $3d1fb7771a650d07$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $3d1fb7771a650d07$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $3d1fb7771a650d07$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $680df362cb03773e$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $680df362cb03773e$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $680df362cb03773e$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $680df362cb03773e$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $680df362cb03773e$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $680df362cb03773e$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $680df362cb03773e$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $680df362cb03773e$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $3d1fb7771a650d07$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $680df362cb03773e$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $680df362cb03773e$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $680df362cb03773e$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $680df362cb03773e$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $680df362cb03773e$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $3d1fb7771a650d07$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $680df362cb03773e$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $680df362cb03773e$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $680df362cb03773e$export$803cd8101b6c182b) ? $3d1fb7771a650d07$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $680df362cb03773e$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $680df362cb03773e$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $680df362cb03773e$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $680df362cb03773e$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $3d1fb7771a650d07$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $680df362cb03773e$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $680df362cb03773e$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $680df362cb03773e$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $680df362cb03773e$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $680df362cb03773e$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $680df362cb03773e$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $680df362cb03773e$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $680df362cb03773e$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $680df362cb03773e$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $680df362cb03773e$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $680df362cb03773e$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $3d1fb7771a650d07$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $3d1fb7771a650d07$var$isAnySideFullyClipped(overflow) {
    return (0, $680df362cb03773e$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $3d1fb7771a650d07$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $680df362cb03773e$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $3d1fb7771a650d07$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $3d1fb7771a650d07$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $3d1fb7771a650d07$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $3d1fb7771a650d07$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $3d1fb7771a650d07$var$getBoundingRect(rects) {
    const minX = (0, $680df362cb03773e$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $680df362cb03773e$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $680df362cb03773e$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $680df362cb03773e$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $3d1fb7771a650d07$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $680df362cb03773e$export$ee05aea0aeecbad4)($3d1fb7771a650d07$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $3d1fb7771a650d07$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $680df362cb03773e$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $3d1fb7771a650d07$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $680df362cb03773e$export$ee05aea0aeecbad4)($3d1fb7771a650d07$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $680df362cb03773e$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $680df362cb03773e$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $680df362cb03773e$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $680df362cb03773e$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $680df362cb03773e$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $680df362cb03773e$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $3d1fb7771a650d07$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $3d1fb7771a650d07$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $680df362cb03773e$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $680df362cb03773e$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $680df362cb03773e$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $3d1fb7771a650d07$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $680df362cb03773e$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $3d1fb7771a650d07$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $3d1fb7771a650d07$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $3d1fb7771a650d07$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $680df362cb03773e$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $680df362cb03773e$export$f28e8f882010718a)((0, $680df362cb03773e$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $680df362cb03773e$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $680df362cb03773e$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $680df362cb03773e$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $3d1fb7771a650d07$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $680df362cb03773e$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $680df362cb03773e$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $680df362cb03773e$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $680df362cb03773e$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $3d1fb7771a650d07$var$originSides.has((0, $680df362cb03773e$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $3d1fb7771a650d07$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $680df362cb03773e$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $680df362cb03773e$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $680df362cb03773e$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $680df362cb03773e$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $680df362cb03773e$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $680df362cb03773e$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $680df362cb03773e$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $680df362cb03773e$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $680df362cb03773e$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $680df362cb03773e$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $680df362cb03773e$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $680df362cb03773e$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $026ed72e8040752d$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $026ed72e8040752d$export$651544f548703224(node) {
    if ($026ed72e8040752d$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $026ed72e8040752d$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $026ed72e8040752d$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($026ed72e8040752d$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $026ed72e8040752d$export$8ee0fc9ee280b4ee(value) {
    if (!$026ed72e8040752d$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $026ed72e8040752d$export$38b2d434cce3ea22(value).Node;
}
function $026ed72e8040752d$export$45a5e7f76e0caa8d(value) {
    if (!$026ed72e8040752d$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $026ed72e8040752d$export$38b2d434cce3ea22(value).Element;
}
function $026ed72e8040752d$export$1b3bfaa9684536aa(value) {
    if (!$026ed72e8040752d$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $026ed72e8040752d$export$38b2d434cce3ea22(value).HTMLElement;
}
function $026ed72e8040752d$export$af51f0f06c0f328a(value) {
    if (!$026ed72e8040752d$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $026ed72e8040752d$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $026ed72e8040752d$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $026ed72e8040752d$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $026ed72e8040752d$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($026ed72e8040752d$export$651544f548703224(element));
}
function $026ed72e8040752d$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $026ed72e8040752d$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $026ed72e8040752d$var$containRe = /paint|layout|strict|content/;
const $026ed72e8040752d$var$isNotNone = (value)=>!!value && value !== 'none';
let $026ed72e8040752d$var$isWebKitValue;
function $026ed72e8040752d$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $026ed72e8040752d$export$45a5e7f76e0caa8d(elementOrCss) ? $026ed72e8040752d$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $026ed72e8040752d$var$isNotNone(css.transform) || $026ed72e8040752d$var$isNotNone(css.translate) || $026ed72e8040752d$var$isNotNone(css.scale) || $026ed72e8040752d$var$isNotNone(css.rotate) || $026ed72e8040752d$var$isNotNone(css.perspective) || !$026ed72e8040752d$export$78551043582a6a98() && ($026ed72e8040752d$var$isNotNone(css.backdropFilter) || $026ed72e8040752d$var$isNotNone(css.filter)) || $026ed72e8040752d$var$willChangeRe.test(css.willChange || '') || $026ed72e8040752d$var$containRe.test(css.contain || '');
}
function $026ed72e8040752d$export$940d8225183e1404(element) {
    let currentNode = $026ed72e8040752d$export$4e12058fc4d51d56(element);
    while($026ed72e8040752d$export$1b3bfaa9684536aa(currentNode) && !$026ed72e8040752d$export$d1162fb0b6d4cd51(currentNode)){
        if ($026ed72e8040752d$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($026ed72e8040752d$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $026ed72e8040752d$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $026ed72e8040752d$export$78551043582a6a98() {
    if ($026ed72e8040752d$var$isWebKitValue == null) $026ed72e8040752d$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $026ed72e8040752d$var$isWebKitValue;
}
function $026ed72e8040752d$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($026ed72e8040752d$export$651544f548703224(node));
}
function $026ed72e8040752d$export$3735103072e4a80(element) {
    return $026ed72e8040752d$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $026ed72e8040752d$export$dc8fc79fa2800137(element) {
    if ($026ed72e8040752d$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $026ed72e8040752d$export$4e12058fc4d51d56(node) {
    if ($026ed72e8040752d$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $026ed72e8040752d$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $026ed72e8040752d$export$e495491855dc5418(node);
    return $026ed72e8040752d$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $026ed72e8040752d$export$7cd01a57c8ca906c(node) {
    const parentNode = $026ed72e8040752d$export$4e12058fc4d51d56(node);
    if ($026ed72e8040752d$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($026ed72e8040752d$export$1b3bfaa9684536aa(parentNode) && $026ed72e8040752d$export$989e911fa9af580a(parentNode)) return parentNode;
    return $026ed72e8040752d$export$7cd01a57c8ca906c(parentNode);
}
function $026ed72e8040752d$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $026ed72e8040752d$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $026ed72e8040752d$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $026ed72e8040752d$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $026ed72e8040752d$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $026ed72e8040752d$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $026ed72e8040752d$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $026ed72e8040752d$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $18413a461db0a850$var$getCssDimensions(element) {
    const css = (0, $026ed72e8040752d$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $026ed72e8040752d$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $680df362cb03773e$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $680df362cb03773e$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $18413a461db0a850$var$unwrapElement(element) {
    return !(0, $026ed72e8040752d$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $18413a461db0a850$var$getScale(element) {
    const domElement = $18413a461db0a850$var$unwrapElement(element);
    if (!(0, $026ed72e8040752d$export$1b3bfaa9684536aa)(domElement)) return (0, $680df362cb03773e$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $18413a461db0a850$var$getCssDimensions(domElement);
    let x = ($ ? (0, $680df362cb03773e$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $680df362cb03773e$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $18413a461db0a850$var$noOffsets = /*#__PURE__*/ (0, $680df362cb03773e$export$a397704b5e280835)(0);
function $18413a461db0a850$var$getVisualOffsets(element) {
    const win = (0, $026ed72e8040752d$export$38b2d434cce3ea22)(element);
    if (!(0, $026ed72e8040752d$export$78551043582a6a98)() || !win.visualViewport) return $18413a461db0a850$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $18413a461db0a850$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $026ed72e8040752d$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $18413a461db0a850$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $18413a461db0a850$var$unwrapElement(element);
    let scale = (0, $680df362cb03773e$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $026ed72e8040752d$export$45a5e7f76e0caa8d)(offsetParent)) scale = $18413a461db0a850$var$getScale(offsetParent);
        } else scale = $18413a461db0a850$var$getScale(element);
    }
    const visualOffsets = $18413a461db0a850$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $18413a461db0a850$var$getVisualOffsets(domElement) : (0, $680df362cb03773e$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $026ed72e8040752d$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $026ed72e8040752d$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $026ed72e8040752d$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $026ed72e8040752d$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $18413a461db0a850$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $026ed72e8040752d$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $026ed72e8040752d$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $026ed72e8040752d$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $680df362cb03773e$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $18413a461db0a850$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $026ed72e8040752d$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $18413a461db0a850$var$getBoundingClientRect((0, $026ed72e8040752d$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $18413a461db0a850$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $18413a461db0a850$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $18413a461db0a850$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $026ed72e8040752d$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $026ed72e8040752d$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $680df362cb03773e$export$a397704b5e280835)(1);
    const offsets = (0, $680df362cb03773e$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $026ed72e8040752d$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $026ed72e8040752d$export$651544f548703224)(offsetParent) !== 'body' || (0, $026ed72e8040752d$export$989e911fa9af580a)(documentElement)) scroll = (0, $026ed72e8040752d$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $18413a461db0a850$var$getBoundingClientRect(offsetParent);
            scale = $18413a461db0a850$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $18413a461db0a850$var$getHTMLOffset(documentElement, scroll) : (0, $680df362cb03773e$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $18413a461db0a850$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $18413a461db0a850$var$getDocumentRect(element) {
    const html = (0, $026ed72e8040752d$export$e495491855dc5418)(element);
    const scroll = (0, $026ed72e8040752d$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $680df362cb03773e$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $680df362cb03773e$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $18413a461db0a850$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $026ed72e8040752d$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $680df362cb03773e$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $18413a461db0a850$var$SCROLLBAR_MAX = 25;
function $18413a461db0a850$var$getViewportRect(element, strategy) {
    const win = (0, $026ed72e8040752d$export$38b2d434cce3ea22)(element);
    const html = (0, $026ed72e8040752d$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $026ed72e8040752d$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $18413a461db0a850$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $18413a461db0a850$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $18413a461db0a850$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $18413a461db0a850$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $18413a461db0a850$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $026ed72e8040752d$export$1b3bfaa9684536aa)(element) ? $18413a461db0a850$var$getScale(element) : (0, $680df362cb03773e$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $18413a461db0a850$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $18413a461db0a850$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $18413a461db0a850$var$getDocumentRect((0, $026ed72e8040752d$export$e495491855dc5418)(element));
    else if ((0, $026ed72e8040752d$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $18413a461db0a850$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $18413a461db0a850$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $680df362cb03773e$export$ee05aea0aeecbad4)(rect);
}
function $18413a461db0a850$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $026ed72e8040752d$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $026ed72e8040752d$export$45a5e7f76e0caa8d)(parentNode) || (0, $026ed72e8040752d$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $026ed72e8040752d$export$3735103072e4a80)(parentNode).position === 'fixed' || $18413a461db0a850$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $18413a461db0a850$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $026ed72e8040752d$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $026ed72e8040752d$export$45a5e7f76e0caa8d)(el) && (0, $026ed72e8040752d$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $026ed72e8040752d$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $026ed72e8040752d$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $026ed72e8040752d$export$45a5e7f76e0caa8d)(currentNode) && !(0, $026ed72e8040752d$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $026ed72e8040752d$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $026ed72e8040752d$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $026ed72e8040752d$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $18413a461db0a850$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $026ed72e8040752d$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $18413a461db0a850$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $026ed72e8040752d$export$89e651af02346cd4)(element) ? [] : $18413a461db0a850$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $18413a461db0a850$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $18413a461db0a850$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $680df362cb03773e$export$8960430cfd85939f)(rect.top, top);
        right = (0, $680df362cb03773e$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $680df362cb03773e$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $680df362cb03773e$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $18413a461db0a850$var$getDimensions(element) {
    const { width: width, height: height } = $18413a461db0a850$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $18413a461db0a850$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $026ed72e8040752d$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $026ed72e8040752d$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $18413a461db0a850$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $680df362cb03773e$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $18413a461db0a850$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $026ed72e8040752d$export$651544f548703224)(offsetParent) !== 'body' || (0, $026ed72e8040752d$export$989e911fa9af580a)(documentElement)) scroll = (0, $026ed72e8040752d$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $18413a461db0a850$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $18413a461db0a850$var$getHTMLOffset(documentElement, scroll) : (0, $680df362cb03773e$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $18413a461db0a850$var$isStaticPositioned(element) {
    return (0, $026ed72e8040752d$export$3735103072e4a80)(element).position === 'static';
}
function $18413a461db0a850$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $026ed72e8040752d$export$1b3bfaa9684536aa)(element) || (0, $026ed72e8040752d$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $026ed72e8040752d$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $18413a461db0a850$var$getOffsetParent(element, polyfill) {
    const win = (0, $026ed72e8040752d$export$38b2d434cce3ea22)(element);
    if ((0, $026ed72e8040752d$export$89e651af02346cd4)(element)) return win;
    if (!(0, $026ed72e8040752d$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $026ed72e8040752d$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $026ed72e8040752d$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $026ed72e8040752d$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$18413a461db0a850$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $026ed72e8040752d$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $18413a461db0a850$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $026ed72e8040752d$export$71535ffaa902797f)(offsetParent) && $18413a461db0a850$var$isStaticPositioned(offsetParent))offsetParent = $18413a461db0a850$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $026ed72e8040752d$export$d1162fb0b6d4cd51)(offsetParent) && $18413a461db0a850$var$isStaticPositioned(offsetParent) && !(0, $026ed72e8040752d$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $026ed72e8040752d$export$940d8225183e1404)(element) || win;
}
const $18413a461db0a850$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $18413a461db0a850$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $18413a461db0a850$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $18413a461db0a850$var$isRTL(element) {
    return (0, $026ed72e8040752d$export$3735103072e4a80)(element).direction === 'rtl';
}
const $18413a461db0a850$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $18413a461db0a850$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $026ed72e8040752d$export$e495491855dc5418,
    getClippingRect: $18413a461db0a850$var$getClippingRect,
    getOffsetParent: $18413a461db0a850$var$getOffsetParent,
    getElementRects: $18413a461db0a850$var$getElementRects,
    getClientRects: $18413a461db0a850$var$getClientRects,
    getDimensions: $18413a461db0a850$var$getDimensions,
    getScale: $18413a461db0a850$var$getScale,
    isElement: $026ed72e8040752d$export$45a5e7f76e0caa8d,
    isRTL: $18413a461db0a850$var$isRTL
};
function $18413a461db0a850$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $18413a461db0a850$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $026ed72e8040752d$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $680df362cb03773e$export$a3fe094919f356fd)(top);
        const insetRight = (0, $680df362cb03773e$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $680df362cb03773e$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $680df362cb03773e$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $680df362cb03773e$export$8960430cfd85939f)(0, (0, $680df362cb03773e$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$18413a461db0a850$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $18413a461db0a850$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $18413a461db0a850$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $026ed72e8040752d$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $026ed72e8040752d$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $18413a461db0a850$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $18413a461db0a850$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $18413a461db0a850$var$getBoundingClientRect(reference);
        if (prevRefRect && !$18413a461db0a850$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $18413a461db0a850$export$37b6bde19b108ecc = (0, $3d1fb7771a650d07$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $18413a461db0a850$export$cc800923e997bb8 = (0, $3d1fb7771a650d07$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $18413a461db0a850$export$91fb6ecbd551914 = (0, $3d1fb7771a650d07$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $18413a461db0a850$export$fba63a578e423eb = (0, $3d1fb7771a650d07$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $18413a461db0a850$export$8a83211c878a3f1f = (0, $3d1fb7771a650d07$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $18413a461db0a850$export$346677f925de839c = (0, $3d1fb7771a650d07$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $18413a461db0a850$export$fe8985bb6374093c = (0, $3d1fb7771a650d07$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $18413a461db0a850$export$f2120bbfa5450bd2 = (0, $3d1fb7771a650d07$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $18413a461db0a850$export$18c8ad048e32c7d5 = (0, $3d1fb7771a650d07$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $18413a461db0a850$export$7bf07e38f3dc4b69 = (0, $3d1fb7771a650d07$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $18413a461db0a850$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $18413a461db0a850$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $3d1fb7771a650d07$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};


var $b7e8a4ad65e86607$var$_dec, $b7e8a4ad65e86607$var$_class, $b7e8a4ad65e86607$var$_descriptor, $b7e8a4ad65e86607$var$_BCTooltip;
function $b7e8a4ad65e86607$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $b7e8a4ad65e86607$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function $b7e8a4ad65e86607$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
/*
  https://floating-ui.com/docs/getting-started
*/ // Events to turn on/off the tooltip
const $b7e8a4ad65e86607$var$hasTouchCapability = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
const $b7e8a4ad65e86607$var$enterEvents = $b7e8a4ad65e86607$var$hasTouchCapability ? [
    "touchstart"
] : [
    "mouseenter"
];
const $b7e8a4ad65e86607$var$leaveEvents = [
    "mouseleave"
];
let $b7e8a4ad65e86607$export$9673bd7d20874c66 = ($b7e8a4ad65e86607$var$_dec = (0, $9dde40d50caa9c07$export$2fa187e846a241c4)(".tooltip-arrow"), $b7e8a4ad65e86607$var$_class = ($b7e8a4ad65e86607$var$_BCTooltip = class BCTooltip extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    // Lazy creation
    static lazy(target, callback) {
        const createTooltip = ()=>{
            const tooltip = document.createElement("bc-tooltip");
            callback(tooltip);
            target.parentNode.insertBefore(tooltip, target.nextSibling);
            tooltip.show();
            // We only need to create the tooltip once, so ignore all future events.
            $b7e8a4ad65e86607$var$enterEvents.forEach((eventName)=>target.removeEventListener(eventName, createTooltip));
        };
        $b7e8a4ad65e86607$var$enterEvents.forEach((eventName)=>target.addEventListener(eventName, createTooltip));
    }
    constructor(){
        super();
        // Attribute for styling "showing"
        $b7e8a4ad65e86607$var$_initializerDefineProperty(this, "_arrowElement", $b7e8a4ad65e86607$var$_descriptor, this);
        this._target = null;
        this.show = (e)=>{
            this.showCloseIcon = e.type == "touchstart";
            this.style.cssText = "";
            this.style.display = "block";
            (0, $18413a461db0a850$export$48a53dcb22e581d0)(this.target, this, {
                strategy: "absolute",
                middleware: [
                    (0, $18413a461db0a850$export$cc800923e997bb8)(this.offset),
                    (0, $18413a461db0a850$export$18c8ad048e32c7d5)(),
                    // flip(),
                    (0, $18413a461db0a850$export$fba63a578e423eb)(),
                    (0, $18413a461db0a850$export$91fb6ecbd551914)({
                        allowedPlacements: [
                            "top",
                            "bottom",
                            "right",
                            "left"
                        ]
                    }),
                    (0, $18413a461db0a850$export$f2120bbfa5450bd2)({
                        element: this._arrowElement
                    })
                ]
            }).then(({ x: x, y: y, middlewareData: middlewareData, placement: placement })=>{
                Object.assign(this.style, {
                    left: `${x}px`,
                    top: `${y}px`
                });
                if (middlewareData.arrow) {
                    const { x: x, y: y } = middlewareData.arrow;
                    Object.assign(this._arrowElement.style, {
                        left: x != null ? `${x}px` : "",
                        top: y != null ? `${y}px` : ""
                    });
                    this._arrowElement.classList.remove("on-top", "on-bottom", "on-left", "on-right");
                    this._arrowElement.classList.add("on-" + placement);
                }
            });
            this.showing = true;
        };
        this.hide = ()=>{
            this.showing = false;
            this.style.display = "none";
        };
        this.showing = false;
        // Position offset
        this.offset = 10;
    }
    connectedCallback() {
        super.connectedCallback();
        this.target ??= this.previousElementSibling;
    }
    get target() {
        return this._target;
    }
    set target(target) {
        if (this.target) {
            $b7e8a4ad65e86607$var$enterEvents.forEach((name)=>this.target.removeEventListener(name, this.show));
            $b7e8a4ad65e86607$var$leaveEvents.forEach((name)=>this.target.removeEventListener(name, this.hide));
        }
        if (target) {
            // Add events to new target
            $b7e8a4ad65e86607$var$enterEvents.forEach((name)=>target.addEventListener(name, this.show));
            $b7e8a4ad65e86607$var$leaveEvents.forEach((name)=>target.addEventListener(name, this.hide));
        }
        this._target = target;
    }
    render() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
      <button ?hidden=${!this.showCloseIcon} class="c-icon-close-tooltip" @click=${()=>this.hide()}></button>
      <slot></slot>
      <div id="arrow" class="tooltip-arrow"></div>
    `;
    }
}, $b7e8a4ad65e86607$var$_BCTooltip.properties = {
    showing: {
        reflect: true,
        type: Boolean
    },
    showCloseIcon: {
        reflect: true,
        type: Boolean
    },
    offset: {
        type: Number
    },
    side: {
        type: String,
        attribute: "data-tooltip-side"
    }
}, $b7e8a4ad65e86607$var$_BCTooltip.styles = [
    (0, $42f4265c0ce36ff0$export$da69cd37b7514c47)
], $b7e8a4ad65e86607$var$_BCTooltip), $b7e8a4ad65e86607$var$_descriptor = $b7e8a4ad65e86607$var$_applyDecoratedDescriptor($b7e8a4ad65e86607$var$_class.prototype, "_arrowElement", [
    $b7e8a4ad65e86607$var$_dec
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
}), $b7e8a4ad65e86607$var$_class);
class $b7e8a4ad65e86607$var$TooltipDirective extends (0, $cc5562de03e1a67c$export$befdefbdce210f91) {
    constructor(...args){
        super(...args);
        this.didSetupLazy = false;
        this.tooltipContent = void 0;
        this.part = void 0;
        this.tooltip = void 0;
    }
    render(tooltipContent = "") {}
    update(part, [tooltipContent]) {
        this.tooltipContent = tooltipContent;
        this.part = part;
        if (!this.didSetupLazy) this.setupLazy();
        if (this.tooltip) this.renderTooltipContent();
    }
    setupLazy() {
        this.didSetupLazy = true;
        $b7e8a4ad65e86607$export$9673bd7d20874c66.lazy(this.part.element, (tooltip)=>{
            this.tooltip = tooltip;
            this.renderTooltipContent();
        });
    }
    renderTooltipContent() {
        (0, $bd6886d5707a45a8$export$b3890eb0ae9dca99)(this.tooltipContent, this.tooltip, this.part.options);
    }
}
const $b7e8a4ad65e86607$export$7934a1fe8ff0c156 = ()=>{
    if (!window.customElements.get("bc-tooltip")) customElements.define("bc-tooltip", $b7e8a4ad65e86607$export$9673bd7d20874c66);
};
const $b7e8a4ad65e86607$export$4e6f96734dfe12f4 = (0, $cc5562de03e1a67c$export$99b43ad1ed32e735)($b7e8a4ad65e86607$var$TooltipDirective);





/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $aac2fe32bc5ff8e1$export$56cc687933817664 = (0, $cc5562de03e1a67c$export$99b43ad1ed32e735)(class extends (0, $cc5562de03e1a67c$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $cc5562de03e1a67c$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $bd6886d5707a45a8$export$9c068ae9cc5db4e8;
    }
});





const $93845cf907d8bb73$export$4d1a6f24a7bf3aea = (0, $2ebca2d23ae8704c$export$dbf350e5966cf602)`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

.bc-loading {
  flex-direction: column;
  align-items: center;
  display: flex;
}

.bc-loading:not(.bc-loading--inline) {
  z-index: 30;
  background: var(--color-grey--x-light);
  opacity: .8;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
}

h2 {
  text-align: center;
}

.bc-ellipsis {
  width: 80px;
  height: 80px;
  display: inline-block;
  position: relative;
}

.bc-ellipsis div {
  background: var(--color-grey--dark);
  border-radius: 50%;
  width: 13px;
  height: 13px;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
  position: absolute;
  top: 33px;
}

.bc-ellipsis div:first-child {
  animation: .6s infinite bc-ellipsis1;
  left: 8px;
}

.bc-ellipsis div:nth-child(2) {
  animation: .6s infinite bc-ellipsis2;
  left: 8px;
}

.bc-ellipsis div:nth-child(3) {
  animation: .6s infinite bc-ellipsis2;
  left: 32px;
}

.bc-ellipsis div:nth-child(4) {
  animation: .6s infinite bc-ellipsis3;
  left: 56px;
}

@keyframes bc-ellipsis1 {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes bc-ellipsis3 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes bc-ellipsis2 {
  0% {
    transform: translate(0);
  }

  100% {
    transform: translate(24px);
  }
}
`;


class $c0224998cf8b7c3f$var$BCLoadingIcon extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    static get properties() {
        return {
            loadingTitle: {
                type: String,
                attribute: "data-loading-title"
            },
            inline: {
                type: Boolean,
                reflect: true,
                default: false,
                attribute: "data-inline"
            }
        };
    }
    render() {
        const classes = {
            "bc-loading": true,
            "bc-loading--inline": this.inline
        };
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<div class=${(0, $aac2fe32bc5ff8e1$export$56cc687933817664)(classes)}>
      ${this.loadingTitle ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<h2>${this.loadingTitle}</h2>` : (0, $bd6886d5707a45a8$export$45b790e32b2810ee)}
      <div class="bc-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>`;
    }
}
$c0224998cf8b7c3f$var$BCLoadingIcon.styles = [
    (0, $93845cf907d8bb73$export$4d1a6f24a7bf3aea)
];
const $c0224998cf8b7c3f$export$324571b27622cdf8 = ()=>{
    if (!window.customElements.get("bc-loading-icon")) customElements.define("bc-loading-icon", $c0224998cf8b7c3f$var$BCLoadingIcon);
};



class $cca191d6e1c32022$var$BCAbbr extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    static get properties() {
        return {
            tooltip: {
                type: String,
                reflect: true
            }
        };
    }
    render() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<abbr title="${this.tooltip}"><slot></slot></abbr>
      ${this.tooltip ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<bc-tooltip data-trigger-style="dashed">${this.tooltip}</bc-tooltip>` : ""} `;
    }
}
const $cca191d6e1c32022$export$5b26f5125ff18a6b = ()=>{
    if (!window.customElements.get("bc-abbr")) customElements.define("bc-abbr", $cca191d6e1c32022$var$BCAbbr);
};






const $1bd6424b838405bb$export$36930b080855a681 = (0, $2ebca2d23ae8704c$export$dbf350e5966cf602)`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

.c-link {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  cursor: pointer;
  font-weight: bold;
  display: inline-block;
}

.c-link--accent {
  color: var(--color-brand--accent);
}

.c-link--accent:hover {
  color: var(--color-brand--support);
  text-decoration: none;
}

.c-link--underline {
  font-weight: normal;
  text-decoration: underline;
}

.c-link--underline:hover {
  text-decoration: none;
}

.m0 {
  margin: 0 !important;
}

.mt0 {
  margin-top: 0 !important;
}

.mr0 {
  margin-right: 0 !important;
}

.mb0 {
  margin-bottom: 0 !important;
}

.ml0 {
  margin-left: 0 !important;
}

.mv0 {
  margin-block: 0 !important;
}

.mh0 {
  margin-inline: 0 !important;
}

.m-- {
  margin: .313rem !important;
}

.mt-- {
  margin-top: .313rem !important;
}

.mr-- {
  margin-right: .313rem !important;
}

.mb-- {
  margin-bottom: .313rem !important;
}

.ml-- {
  margin-left: .313rem !important;
}

.mv-- {
  margin-block: .313rem !important;
}

.mh-- {
  margin-inline: .313rem !important;
}

.m- {
  margin: .625rem !important;
}

.mt- {
  margin-top: .625rem !important;
}

.mr- {
  margin-right: .625rem !important;
}

.mb- {
  margin-bottom: .625rem !important;
}

.ml- {
  margin-left: .625rem !important;
}

.mv- {
  margin-block: .625rem !important;
}

.mh- {
  margin-inline: .625rem !important;
}

.m {
  margin: 1.25rem !important;
}

.mt {
  margin-top: 1.25rem !important;
}

.mr {
  margin-right: 1.25rem !important;
}

.mb {
  margin-bottom: 1.25rem !important;
}

.ml {
  margin-left: 1.25rem !important;
}

.mv {
  margin-block: 1.25rem !important;
}

.mh {
  margin-inline: 1.25rem !important;
}

.m\\+ {
  margin: 2.5rem !important;
}

.mt\\+ {
  margin-top: 2.5rem !important;
}

.mr\\+ {
  margin-right: 2.5rem !important;
}

.mb\\+ {
  margin-bottom: 2.5rem !important;
}

.ml\\+ {
  margin-left: 2.5rem !important;
}

.mv\\+ {
  margin-block: 2.5rem !important;
}

.mh\\+ {
  margin-inline: 2.5rem !important;
}

.m\\+\\+ {
  margin: 5rem !important;
}

.mt\\+\\+ {
  margin-top: 5rem !important;
}

.mr\\+\\+ {
  margin-right: 5rem !important;
}

.mb\\+\\+ {
  margin-bottom: 5rem !important;
}

.ml\\+\\+ {
  margin-left: 5rem !important;
}

.mv\\+\\+ {
  margin-block: 5rem !important;
}

.mh\\+\\+ {
  margin-inline: 5rem !important;
}

.p0 {
  padding: 0 !important;
}

.pt0 {
  padding-top: 0 !important;
}

.pr0 {
  padding-right: 0 !important;
}

.pb0 {
  padding-bottom: 0 !important;
}

.pl0 {
  padding-left: 0 !important;
}

.pv0 {
  padding-block: 0 !important;
}

.ph0 {
  padding-inline: 0 !important;
}

.p-- {
  padding: .313rem !important;
}

.pt-- {
  padding-top: .313rem !important;
}

.pr-- {
  padding-right: .313rem !important;
}

.pb-- {
  padding-bottom: .313rem !important;
}

.pl-- {
  padding-left: .313rem !important;
}

.pv-- {
  padding-block: .313rem !important;
}

.ph-- {
  padding-inline: .313rem !important;
}

.p- {
  padding: .625rem !important;
}

.pt- {
  padding-top: .625rem !important;
}

.pr- {
  padding-right: .625rem !important;
}

.pb- {
  padding-bottom: .625rem !important;
}

.pl- {
  padding-left: .625rem !important;
}

.pv- {
  padding-block: .625rem !important;
}

.ph- {
  padding-inline: .625rem !important;
}

.p {
  padding: 1.25rem !important;
}

.pt {
  padding-top: 1.25rem !important;
}

.pr {
  padding-right: 1.25rem !important;
}

.pb {
  padding-bottom: 1.25rem !important;
}

.pl {
  padding-left: 1.25rem !important;
}

.pv {
  padding-block: 1.25rem !important;
}

.ph {
  padding-inline: 1.25rem !important;
}

.p\\+ {
  padding: 2.5rem !important;
}

.pt\\+ {
  padding-top: 2.5rem !important;
}

.pr\\+ {
  padding-right: 2.5rem !important;
}

.pb\\+ {
  padding-bottom: 2.5rem !important;
}

.pl\\+ {
  padding-left: 2.5rem !important;
}

.pv\\+ {
  padding-block: 2.5rem !important;
}

.ph\\+ {
  padding-inline: 2.5rem !important;
}

.p\\+\\+ {
  padding: 5rem !important;
}

.pt\\+\\+ {
  padding-top: 5rem !important;
}

.pr\\+\\+ {
  padding-right: 5rem !important;
}

.pb\\+\\+ {
  padding-bottom: 5rem !important;
}

.pl\\+\\+ {
  padding-left: 5rem !important;
}

.pv\\+\\+ {
  padding-block: 5rem !important;
}

.ph\\+\\+ {
  padding-inline: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .m0\\(s\\) {
    margin: 0 !important;
  }

  .mt0\\(s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(s\\) {
    margin: .313rem !important;
  }

  .mt--\\(s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(s\\) {
    margin: .625rem !important;
  }

  .mt-\\(s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(s\\) {
    padding: 0 !important;
  }

  .pt0\\(s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(s\\) {
    padding: .313rem !important;
  }

  .pt--\\(s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(s\\) {
    padding: .625rem !important;
  }

  .pt-\\(s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .m0\\(m\\) {
    margin: 0 !important;
  }

  .mt0\\(m\\) {
    margin-top: 0 !important;
  }

  .mr0\\(m\\) {
    margin-right: 0 !important;
  }

  .mb0\\(m\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(m\\) {
    margin-left: 0 !important;
  }

  .mv0\\(m\\) {
    margin-block: 0 !important;
  }

  .mh0\\(m\\) {
    margin-inline: 0 !important;
  }

  .m--\\(m\\) {
    margin: .313rem !important;
  }

  .mt--\\(m\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(m\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(m\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(m\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(m\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(m\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(m\\) {
    margin: .625rem !important;
  }

  .mt-\\(m\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(m\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(m\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(m\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(m\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(m\\) {
    margin-inline: .625rem !important;
  }

  .m\\(m\\) {
    margin: 1.25rem !important;
  }

  .mt\\(m\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(m\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(m\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(m\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(m\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(m\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(m\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(m\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(m\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(m\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(m\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(m\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(m\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(m\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(m\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(m\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(m\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(m\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(m\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(m\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(m\\) {
    padding: 0 !important;
  }

  .pt0\\(m\\) {
    padding-top: 0 !important;
  }

  .pr0\\(m\\) {
    padding-right: 0 !important;
  }

  .pb0\\(m\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(m\\) {
    padding-left: 0 !important;
  }

  .pv0\\(m\\) {
    padding-block: 0 !important;
  }

  .ph0\\(m\\) {
    padding-inline: 0 !important;
  }

  .p--\\(m\\) {
    padding: .313rem !important;
  }

  .pt--\\(m\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(m\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(m\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(m\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(m\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(m\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(m\\) {
    padding: .625rem !important;
  }

  .pt-\\(m\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(m\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(m\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(m\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(m\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(m\\) {
    padding-inline: .625rem !important;
  }

  .p\\(m\\) {
    padding: 1.25rem !important;
  }

  .pt\\(m\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(m\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(m\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(m\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(m\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(m\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(m\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(m\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(m\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(m\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(m\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(m\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(m\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(m\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(m\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(m\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(m\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(m\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(m\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(m\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .m0\\(\\!s\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!s\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!s\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!s\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!s\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!s\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .m0\\(\\!l\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!l\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!l\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!l\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!l\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!l\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .m0\\(l\\) {
    margin: 0 !important;
  }

  .mt0\\(l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(l\\) {
    margin: .313rem !important;
  }

  .mt--\\(l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(l\\) {
    margin: .625rem !important;
  }

  .mt-\\(l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(l\\) {
    padding: 0 !important;
  }

  .pt0\\(l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(l\\) {
    padding: .313rem !important;
  }

  .pt--\\(l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(l\\) {
    padding: .625rem !important;
  }

  .pt-\\(l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .m0\\(xl\\) {
    margin: 0 !important;
  }

  .mt0\\(xl\\) {
    margin-top: 0 !important;
  }

  .mr0\\(xl\\) {
    margin-right: 0 !important;
  }

  .mb0\\(xl\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(xl\\) {
    margin-left: 0 !important;
  }

  .mv0\\(xl\\) {
    margin-block: 0 !important;
  }

  .mh0\\(xl\\) {
    margin-inline: 0 !important;
  }

  .m--\\(xl\\) {
    margin: .313rem !important;
  }

  .mt--\\(xl\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(xl\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(xl\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(xl\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(xl\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(xl\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(xl\\) {
    margin: .625rem !important;
  }

  .mt-\\(xl\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(xl\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(xl\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(xl\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(xl\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(xl\\) {
    margin-inline: .625rem !important;
  }

  .m\\(xl\\) {
    margin: 1.25rem !important;
  }

  .mt\\(xl\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(xl\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(xl\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(xl\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(xl\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(xl\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(xl\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(xl\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(xl\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(xl\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(xl\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(xl\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(xl\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(xl\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(xl\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(xl\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(xl\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(xl\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(xl\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(xl\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(xl\\) {
    padding: 0 !important;
  }

  .pt0\\(xl\\) {
    padding-top: 0 !important;
  }

  .pr0\\(xl\\) {
    padding-right: 0 !important;
  }

  .pb0\\(xl\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(xl\\) {
    padding-left: 0 !important;
  }

  .pv0\\(xl\\) {
    padding-block: 0 !important;
  }

  .ph0\\(xl\\) {
    padding-inline: 0 !important;
  }

  .p--\\(xl\\) {
    padding: .313rem !important;
  }

  .pt--\\(xl\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(xl\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(xl\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(xl\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(xl\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(xl\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(xl\\) {
    padding: .625rem !important;
  }

  .pt-\\(xl\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(xl\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(xl\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(xl\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(xl\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(xl\\) {
    padding-inline: .625rem !important;
  }

  .p\\(xl\\) {
    padding: 1.25rem !important;
  }

  .pt\\(xl\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(xl\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(xl\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(xl\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(xl\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(xl\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(xl\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(xl\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(xl\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(xl\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(xl\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(xl\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(xl\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(xl\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(xl\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(xl\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(xl\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(xl\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(xl\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(xl\\) {
    padding-inline: 5rem !important;
  }
}

.u-gap0 {
  gap: 0 !important;
}

.u-gap-- {
  gap: .313rem !important;
}

.u-gap- {
  gap: .625rem !important;
}

.u-gap {
  gap: 1.25rem !important;
}

.u-gap\\+ {
  gap: 2.5rem !important;
}

.u-gap\\+\\+ {
  gap: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .u-gap0\\(s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-gap0\\(m\\) {
    gap: 0 !important;
  }

  .u-gap--\\(m\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(m\\) {
    gap: .625rem !important;
  }

  .u-gap\\(m\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(m\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(m\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .u-gap0\\(\\!s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-gap0\\(\\!l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .u-gap0\\(l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-gap0\\(xl\\) {
    gap: 0 !important;
  }

  .u-gap--\\(xl\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(xl\\) {
    gap: .625rem !important;
  }

  .u-gap\\(xl\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(xl\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(xl\\) {
    gap: 5rem !important;
  }
}

.c-internal-nav {
  padding-top: 20px;
  position: sticky;
  top: 0;
}

h5 {
  font-size: var(--font-size-l);
  line-height: var(--line-height-l);
  margin: 0;
}

ul {
  padding: 0;
  list-style-type: none;
}

li {
  margin-bottom: 10px;
}
`;


class $13264f5f318530c9$var$BCWJInternalNav extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    constructor(){
        super();
    }
    getLinks() {
        let element = document.getElementById(this.sourceid);
        if (element) {
            const headers = [
                ...element.querySelectorAll("h2,h3,h4,h5")
            ];
            let linkedHeaders = headers.filter((header)=>{
                return header.id;
            }).map((header)=>{
                return {
                    id: header.id,
                    text: header.innerText
                };
            });
            return linkedHeaders;
        }
    }
    render() {
        const links = this.getLinks();
        const baseUrl = window.location.pathname;
        return links.length === 0 ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`` : (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
          <div class="sticky-internal-nav c-internal-nav">
            <h5 class="mb--">${this.title}</h5>
            <ul>
              ${links.map((link)=>{
            return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<li>
                  <a class="c-link c-link--accent" href="${baseUrl}#${link.id}"
                    >${link.text}</a
                  >
                </li>`;
        })}
            </ul>
          </div>
        `;
    }
}
$13264f5f318530c9$var$BCWJInternalNav.styles = [
    (0, $1bd6424b838405bb$export$36930b080855a681)
];
$13264f5f318530c9$var$BCWJInternalNav.properties = {
    sourceid: {},
    title: {}
};
const $13264f5f318530c9$export$b226d6bf775a92f2 = ()=>{
    window.customElements.define("bc-wj-internal-nav", $13264f5f318530c9$var$BCWJInternalNav);
};




/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $90e1d465c1da178e$var$t } = (0, $bd6886d5707a45a8$export$8613d1ca9052b22e), $90e1d465c1da178e$var$i = (o)=>o, $90e1d465c1da178e$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $90e1d465c1da178e$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $90e1d465c1da178e$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $90e1d465c1da178e$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $90e1d465c1da178e$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $90e1d465c1da178e$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $90e1d465c1da178e$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $90e1d465c1da178e$var$s = ()=>document.createComment(""), $90e1d465c1da178e$export$291b2338ad9b0b30 = (o, n, e)=>{
    const l = o._$AA.parentNode, d = void 0 === n ? o._$AB : n._$AA;
    if (void 0 === e) {
        const i = l.insertBefore($90e1d465c1da178e$var$s(), d), n = l.insertBefore($90e1d465c1da178e$var$s(), d);
        e = new $90e1d465c1da178e$var$t(i, n, o, o.options);
    } else {
        const t = e._$AB.nextSibling, n = e._$AM, c = n !== o;
        if (c) {
            let t;
            e._$AQ?.(o), e._$AM = o, void 0 !== e._$AP && (t = o._$AU) !== n._$AU && e._$AP(t);
        }
        if (t !== d || c) {
            let o = e._$AA;
            for(; o !== t;){
                const t = $90e1d465c1da178e$var$i(o).nextSibling;
                $90e1d465c1da178e$var$i(l).insertBefore(o, d), o = t;
            }
        }
    }
    return e;
}, $90e1d465c1da178e$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $90e1d465c1da178e$var$m = {}, $90e1d465c1da178e$export$ea70d9dd5965b1c8 = (o, t = $90e1d465c1da178e$var$m)=>o._$AH = t, $90e1d465c1da178e$export$59e9bce518cde500 = (o)=>o._$AH, $90e1d465c1da178e$export$3133b3144bbba267 = (o)=>{
    o._$AR(), o._$AA.remove();
}, $90e1d465c1da178e$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2535cd2b5cb51947$var$s = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $2535cd2b5cb51947$var$s(i, t);
    return !0;
}, $2535cd2b5cb51947$var$o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $2535cd2b5cb51947$var$r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $2535cd2b5cb51947$var$c(t);
    }
};
function $2535cd2b5cb51947$var$h(i) {
    void 0 !== this._$AN ? ($2535cd2b5cb51947$var$o(this), this._$AM = i, $2535cd2b5cb51947$var$r(this)) : this._$AM = i;
}
function $2535cd2b5cb51947$var$n(i, t = !1, e = 0) {
    const r = this._$AH, h = this._$AN;
    if (void 0 !== h && 0 !== h.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)$2535cd2b5cb51947$var$s(r[i], !1), $2535cd2b5cb51947$var$o(r[i]);
            else null != r && ($2535cd2b5cb51947$var$s(r, !1), $2535cd2b5cb51947$var$o(r));
        } else $2535cd2b5cb51947$var$s(this, i);
    }
}
const $2535cd2b5cb51947$var$c = (i)=>{
    i.type == (0, $cc5562de03e1a67c$export$9ba3b3f20a85bfa).CHILD && (i._$AP ??= $2535cd2b5cb51947$var$n, i._$AQ ??= $2535cd2b5cb51947$var$h);
};
class $2535cd2b5cb51947$export$7d025501802325e extends (0, $cc5562de03e1a67c$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $2535cd2b5cb51947$var$r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($2535cd2b5cb51947$var$s(this, i), $2535cd2b5cb51947$var$o(this));
    }
    setValue(t) {
        if ((0, $90e1d465c1da178e$export$7f431ad0fff82fd9)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c2866c8c0be843b6$export$7d1e3a5e95ceca43 = ()=>new $c2866c8c0be843b6$var$h;
class $c2866c8c0be843b6$var$h {
}
const $c2866c8c0be843b6$var$o = new WeakMap, $c2866c8c0be843b6$export$eff4d24c3ff7876e = (0, $cc5562de03e1a67c$export$99b43ad1ed32e735)(class extends (0, $2535cd2b5cb51947$export$7d025501802325e) {
    render(i) {
        return 0, $bd6886d5707a45a8$export$45b790e32b2810ee;
    }
    update(i, [s]) {
        const e = s !== this.G;
        return e && void 0 !== this.G && this.rt(void 0), (e || this.lt !== this.ct) && (this.G = s, this.ht = i.options?.host, this.rt(this.ct = i.element)), $bd6886d5707a45a8$export$45b790e32b2810ee;
    }
    rt(t) {
        if (this.isConnected || (t = void 0), "function" == typeof this.G) {
            const i = this.ht ?? globalThis;
            let s = $c2866c8c0be843b6$var$o.get(i);
            void 0 === s && (s = new WeakMap, $c2866c8c0be843b6$var$o.set(i, s)), void 0 !== s.get(this.G) && this.G.call(this.ht, void 0), s.set(this.G, t), void 0 !== t && this.G.call(this.ht, t);
        } else this.G.value = t;
    }
    get lt() {
        return "function" == typeof this.G ? $c2866c8c0be843b6$var$o.get(this.ht ?? globalThis)?.get(this.G) : this.G?.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});






const $e557ee19ae2c1966$export$2a938b38c17da265 = (0, $2ebca2d23ae8704c$export$dbf350e5966cf602)`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

.layout {
  flex-wrap: wrap;
  margin: 0 0 0 -20px;
  padding: 0;
  list-style: none;
  display: flex;
}

@media screen and (width >= 47em), print {
  .layout--nowrap {
    flex-wrap: nowrap;
  }
}

.layout--rev {
  flex-direction: row-reverse;
}

.layout--middle {
  align-items: center;
}

.layout--spaced {
  justify-content: space-between;
}

.layout--center {
  justify-content: center;
}

.layout__item {
  width: 100%;
  padding-left: 20px;
}

.layout--auto > .layout__item {
  flex-basis: content;
}

.layout--flush {
  margin-left: 0;
}

.layout--flush > .layout__item {
  padding-left: 0;
}

.layout--small {
  margin-left: -10px;
}

.layout--small > .layout__item {
  padding-left: 10px;
}

.c-button {
  --button-background-color: var(--color-brand);
  --button-text-color: var(--color-white);
  font-size: var(--font-size-button);
  line-height: var(--line-height-button);
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  color: var(--button-text-color);
  background-color: var(--button-background-color);
  border-radius: var(--border-radius-m);
  transition-property: opacity, transform, background-color, color;
  transition-duration: var(--duration-fast);
  transition-timing-function: var(--swift-ease-in-timing-function);
  border: none;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  display: inline-flex;
  position: relative;
  overflow: hidden;
  transform: translateZ(0);
}

.c-button:not(.c-icon-button) {
  padding: calc(1.5 * var(--spacing-)) var(--spacing);
}

.c-button:hover {
  text-decoration: none;
}

.c-button[hidden] {
  display: none;
}

.c-button:before {
  content: "";
  z-index: -1;
  background: var(--color-black);
  opacity: 0;
  transform-origin: 50%;
  transition-property: opacity, transform, background-color, color;
  transition-duration: var(--duration-fast);
  transition-timing-function: var(--swift-ease-in-timing-function);
  border-radius: var(--button-border-radius);
  position: absolute;
  inset: 0;
  transform: scale(.5);
}

.c-button:hover:before, .c-button:active:before {
  opacity: .15;
  transform: scale(1.2);
}

.c-button--small {
  font-size: var(--font-size-m);
  line-height: var(--line-height-s);
  border-radius: var(--border-radius-s);
  padding-top: var(--spacing--) !important;
  padding-bottom: var(--spacing--) !important;
}

.c-button--large {
  padding-top: var(--spacing) !important;
  padding-bottom: var(--spacing) !important;
}

.c-button--support {
  --button-background-color: var(--color-brand--support);
  --button-text-color: var(--color-white);
}

.c-button--accent {
  --button-background-color: var(--color-brand--accent);
  --button-text-color: var(--color-white);
}

.c-button--grey {
  --button-background-color: var(--color-grey--light);
  --button-text-color: var(--color-grey--dark);
}

.c-button--white {
  --button-background-color: var(--color-white);
  --button-text-color: var(--color-grey--dark);
  fill: var(--color-grey--dark);
}

.c-button--white:before {
  background-color: #0000;
}

.c-button--white:hover {
  background-color: hsl(from var(--color-white) h s l / .9);
}

.c-button--ghost {
  --button-background-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-color: inherit;
}

.c-button--ghost:before {
  background-color: var(--color-white);
}

.c-button--disabled, .c-button[disabled] {
  cursor: default;
  --button-background-color: var(--color-grey--light);
}

.c-button--disabled:before, .c-button[disabled]:before {
  display: none;
}

.c-button--fullwidth {
  width: 100%;
}

.c-inputwidget {
  border-radius: var(--border-radius-m);
  box-shadow: 0 5px 25px 0 hsl(from var(--color-black) h s l / .2);
  background-color: var(--color-white);
}

@media screen and (width <= 74.9375em) {
  .c-inputwidget {
    padding: 20px;
  }
}

@media screen and (width >= 75em), print {
  .c-inputwidget {
    padding: 40px;
  }
}

@media screen and (width >= 47em), print {
  .c-inputwidget--home {
    margin-top: -110px;
  }
}

.c-inputwidget__usage {
  max-width: 165px;
  position: relative;
}

.c-inputwidget__usage-unit {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.c-inputwidget__usage-unit .u-size-xlsmall {
  font-size: var(--font-size-xl);
  line-height: var(--line-height-xl);
}

.c-inputwidget__usage-unit .u-size-lsmall {
  font-size: var(--font-size-l);
  line-height: var(--line-height-l);
}

.c-inputwidget__usage-unit .u-size-msmall {
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
}

.c-inputwidget__usage-unit .u-size-ssmall {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
}

.c-inputwidget__usage-unit .u-size-xssmall {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

.c-inputwidget__usage-unit .u-size-h1small {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
  font-style: italic;
  font-weight: bold;
}

.c-inputwidget__usage-unit .u-size-h2small {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
  font-style: italic;
  font-weight: bold;
}

.c-inputwidget__usage-unit .u-size-h3small {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  font-style: italic;
  font-weight: bold;
}

.c-inputwidget__usage-unit .u-size-h4small {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
  font-weight: bold;
}

.c-inputwidget__usage-unit .u-size-h5small {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
  font-weight: bold;
}

.c-inputwidget__usage-unit .u-size-h6small {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  font-weight: bold;
}

.c-inputwidget__usage-unit {
  font-size: var(--font-size-s);
  color: var(--color-grey);
  pointer-events: none;
  right: 10px;
}

.c-inputwidget__electricity-input {
  text-align: right;
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/electricity.svg");
  background-position: 10px;
  background-repeat: no-repeat;
  padding-right: 44px !important;
}

.c-inputwidget__gas-input {
  text-align: right;
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/gas.svg");
  background-position: 10px;
  background-repeat: no-repeat;
  padding-right: 44px !important;
}

.c-link {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  cursor: pointer;
  font-weight: bold;
  display: inline-block;
}

.c-link--accent {
  color: var(--color-brand--accent);
}

.c-link--accent:hover {
  color: var(--color-brand--support);
  text-decoration: none;
}

.c-link--underline {
  font-weight: normal;
  text-decoration: underline;
}

.c-link--underline:hover {
  text-decoration: none;
}

@media screen and (width >= 47em), print {
  .c-inputfields__input--s, .c-inputfields__input--m {
    width: 120px !important;
  }

  .c-inputfields__input--s.c-inputfields__input--inline, .c-inputfields__input--m.c-inputfields__input--inline {
    width: 110px !important;
  }

  .c-inputfields__input--l, .c-inputfields__input--xl {
    width: 320px !important;
  }

  .c-inputfields__input--l.c-inputfields__input--inline, .c-inputfields__input--xl.c-inputfields__input--inline {
    width: 200px !important;
  }
}

@media screen and (width <= 46.9375em) {
  .c-inputfields__input--s.c-inputfields__input--inline, .c-inputfields__input--m.c-inputfields__input--inline {
    width: 36vw !important;
  }

  .c-inputfields__input--l.c-inputfields__input--inline, .c-inputfields__input--xl.c-inputfields__input--inline {
    width: 48vw !important;
  }
}

.c-inputfields__label {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  font-style: normal;
}

.c-inputfields__label--error {
  color: var(--color-status--red);
}

.c-inputfields__label--error input[type="text"], .c-inputfields__label--error input[type="email"], .c-inputfields__label--error input[type="password"], .c-inputfields__label--error input[type="search"], .c-inputfields__label--error input[type="color"], .c-inputfields__label--error input[type="date"], .c-inputfields__label--error input[type="datetime-local"], .c-inputfields__label--error input[type="month"], .c-inputfields__label--error input[type="number"], .c-inputfields__label--error input[type="tel"], .c-inputfields__label--error input[type="time"], .c-inputfields__label--error input[type="url"], .c-inputfields__label--error input[type="week"], .c-inputfields__label--error input[list], .c-inputfields__label--error input[type="file"], .c-inputfields__label--error select, .c-inputfields__label--error textarea {
  border: 1px solid var(--color-status--red);
}

.c-inputfields__input--radio, .c-inputfields__input--checkbox {
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: none !important;
  width: .01em !important;
  height: .01em !important;
  padding: 0 !important;
  position: absolute !important;
  overflow: hidden !important;
}

.c-inputfields__input--radio ~ .c-inputfields__label, .c-inputfields__input--checkbox ~ .c-inputfields__label {
  padding-left: 35px;
  display: inline-block;
  position: relative;
}

.c-inputfields__input--radio ~ .c-inputfields__label:before, .c-inputfields__input--checkbox ~ .c-inputfields__label:before {
  content: "";
  background-color: var(--color-white);
  border: 1px solid var(--color-grey--light);
  width: 20px;
  height: 20px;
  position: absolute;
  top: -1px;
  left: 0;
}

.c-inputfields__input--radio ~ .c-inputfields__label:after, .c-inputfields__input--checkbox ~ .c-inputfields__label:after {
  content: "";
  opacity: 0;
  width: 20px;
  height: 20px;
  transition: all .1s var(--swift-ease-in-out-timing-function);
  position: absolute;
  top: -1px;
  left: 0;
  transform: scale(0);
}

.c-inputfields__input--radio ~ .c-inputfields__label--tight, .c-inputfields__input--checkbox ~ .c-inputfields__label--tight {
  padding-left: 30px;
}

.c-inputfields__input--radio ~ .c-inputfields__label--small:before, .c-inputfields__input--checkbox ~ .c-inputfields__label--small:before {
  border-color: var(--color-grey);
  transform: scale(.7);
}

.c-inputfields__input--radio ~ .c-inputfields__label--block, .c-inputfields__input--checkbox ~ .c-inputfields__label--block {
  display: block;
}

.c-inputfields__input--radio:checked ~ .c-inputfields__label:after, .c-inputfields__input--checkbox:checked ~ .c-inputfields__label:after {
  opacity: 1;
  transform: scale(1);
}

.c-inputfields__input--radio:checked ~ .c-inputfields__label--small:after, .c-inputfields__input--checkbox:checked ~ .c-inputfields__label--small:after {
  transform: scale(.7);
}

.c-inputfields__input--radio:focus ~ .c-inputfields__label:before, .c-inputfields__input--checkbox:focus ~ .c-inputfields__label:before {
  box-shadow: 0 0 4px 0 hsl(from var(--color-brand--accent) h s l / .3);
  border-color: hsl(from var(--color-brand--accent) h s l / .2);
}

.c-inputfields__input--radio:disabled, .c-inputfields__input--checkbox:disabled, .c-inputfields__input--radio:disabled + .c-inputfields__label, .c-inputfields__input--checkbox:disabled + .c-inputfields__label {
  opacity: .5;
}

.c-inputfields__input--radio ~ .c-inputfields__label:before {
  border-radius: var(--border-radius-xl);
}

.c-inputfields__input--radio ~ .c-inputfields__label:after {
  border-radius: var(--border-radius-xl);
  background-color: var(--color-brand--accent);
}

.c-inputfields__input--radio ~ .c-inputfields__label--accent:after {
  background-color: var(--color-brand--accent);
}

.c-inputfields__input--radio:checked ~ .c-inputfields__label:after {
  transform: scale(.6);
}

.c-inputfields__input--checkbox ~ .c-inputfields__label:before {
  border-radius: var(--border-radius-xs);
}

.c-inputfields__input--checkbox ~ .c-inputfields__label:after {
  background: url("data:image/svg+xml,%3Csvg width='14' height='12' viewBox='0 0 14 12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.14.5L4.578 8.59 2.419 6.187c-.471-.52-1.364-.595-1.918-.153a1.3 1.3 0 0 0-.496.914c-.03.358.087.705.33.975l3.255 3.624c.263.288.643.454 1.04.454a1.406 1.406 0 0 0 1.087-.508l7.593-9.361c.229-.282.327-.634.28-.987a1.297 1.297 0 0 0-.541-.89C12.464-.167 11.585-.05 11.14.5z' fill='%23469de6' fill-rule='evenodd'/%3E%3C/svg%3E") center no-repeat;
}

.c-inputfields__input--checkbox:not(:checked) ~ .c-inputfields__label--button:hover {
  border-color: hsl(from var(--color-brand--accent) h s l / .5);
  box-shadow: 0 2px 4px 0 hsl(from var(--color-brand--accent) h s l / .1);
}

.c-inputfields__input--checkbox:not(:checked) ~ .c-inputfields__label--button:hover:after {
  opacity: .5;
  transform: scale(1);
}

.c-select {
  background-image: url("data:image/svg+xml,%3Csvg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_184_4)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 7H0L4 12L8 7ZM8 5H0L4 0L8 5Z' fill='%233D3D3D'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_184_4'%3E%3Crect width='8' height='12' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
  background-position: right .5em top 50%;
  background-repeat: no-repeat;
}

@media screen and (width >= 47em), print {
  .c-form-sidebar--sticky {
    position: sticky;
    top: 20px;
  }
}

.c-form-error {
  scroll-margin-top: 40px;
}

.c-form-error:is(input), .c-form-error:is(select) {
  border: 1px solid var(--color-status--red);
}

.c-form-error:not(select, input) {
  color: var(--color-status--red);
}

.m0 {
  margin: 0 !important;
}

.mt0 {
  margin-top: 0 !important;
}

.mr0 {
  margin-right: 0 !important;
}

.mb0 {
  margin-bottom: 0 !important;
}

.ml0 {
  margin-left: 0 !important;
}

.mv0 {
  margin-block: 0 !important;
}

.mh0 {
  margin-inline: 0 !important;
}

.m-- {
  margin: .313rem !important;
}

.mt-- {
  margin-top: .313rem !important;
}

.mr-- {
  margin-right: .313rem !important;
}

.mb-- {
  margin-bottom: .313rem !important;
}

.ml-- {
  margin-left: .313rem !important;
}

.mv-- {
  margin-block: .313rem !important;
}

.mh-- {
  margin-inline: .313rem !important;
}

.m- {
  margin: .625rem !important;
}

.mt- {
  margin-top: .625rem !important;
}

.mr- {
  margin-right: .625rem !important;
}

.mb- {
  margin-bottom: .625rem !important;
}

.ml- {
  margin-left: .625rem !important;
}

.mv- {
  margin-block: .625rem !important;
}

.mh- {
  margin-inline: .625rem !important;
}

.m {
  margin: 1.25rem !important;
}

.mt {
  margin-top: 1.25rem !important;
}

.mr {
  margin-right: 1.25rem !important;
}

.mb {
  margin-bottom: 1.25rem !important;
}

.ml {
  margin-left: 1.25rem !important;
}

.mv {
  margin-block: 1.25rem !important;
}

.mh {
  margin-inline: 1.25rem !important;
}

.m\\+ {
  margin: 2.5rem !important;
}

.mt\\+ {
  margin-top: 2.5rem !important;
}

.mr\\+ {
  margin-right: 2.5rem !important;
}

.mb\\+ {
  margin-bottom: 2.5rem !important;
}

.ml\\+ {
  margin-left: 2.5rem !important;
}

.mv\\+ {
  margin-block: 2.5rem !important;
}

.mh\\+ {
  margin-inline: 2.5rem !important;
}

.m\\+\\+ {
  margin: 5rem !important;
}

.mt\\+\\+ {
  margin-top: 5rem !important;
}

.mr\\+\\+ {
  margin-right: 5rem !important;
}

.mb\\+\\+ {
  margin-bottom: 5rem !important;
}

.ml\\+\\+ {
  margin-left: 5rem !important;
}

.mv\\+\\+ {
  margin-block: 5rem !important;
}

.mh\\+\\+ {
  margin-inline: 5rem !important;
}

.p0 {
  padding: 0 !important;
}

.pt0 {
  padding-top: 0 !important;
}

.pr0 {
  padding-right: 0 !important;
}

.pb0 {
  padding-bottom: 0 !important;
}

.pl0 {
  padding-left: 0 !important;
}

.pv0 {
  padding-block: 0 !important;
}

.ph0 {
  padding-inline: 0 !important;
}

.p-- {
  padding: .313rem !important;
}

.pt-- {
  padding-top: .313rem !important;
}

.pr-- {
  padding-right: .313rem !important;
}

.pb-- {
  padding-bottom: .313rem !important;
}

.pl-- {
  padding-left: .313rem !important;
}

.pv-- {
  padding-block: .313rem !important;
}

.ph-- {
  padding-inline: .313rem !important;
}

.p- {
  padding: .625rem !important;
}

.pt- {
  padding-top: .625rem !important;
}

.pr- {
  padding-right: .625rem !important;
}

.pb- {
  padding-bottom: .625rem !important;
}

.pl- {
  padding-left: .625rem !important;
}

.pv- {
  padding-block: .625rem !important;
}

.ph- {
  padding-inline: .625rem !important;
}

.p {
  padding: 1.25rem !important;
}

.pt {
  padding-top: 1.25rem !important;
}

.pr {
  padding-right: 1.25rem !important;
}

.pb {
  padding-bottom: 1.25rem !important;
}

.pl {
  padding-left: 1.25rem !important;
}

.pv {
  padding-block: 1.25rem !important;
}

.ph {
  padding-inline: 1.25rem !important;
}

.p\\+ {
  padding: 2.5rem !important;
}

.pt\\+ {
  padding-top: 2.5rem !important;
}

.pr\\+ {
  padding-right: 2.5rem !important;
}

.pb\\+ {
  padding-bottom: 2.5rem !important;
}

.pl\\+ {
  padding-left: 2.5rem !important;
}

.pv\\+ {
  padding-block: 2.5rem !important;
}

.ph\\+ {
  padding-inline: 2.5rem !important;
}

.p\\+\\+ {
  padding: 5rem !important;
}

.pt\\+\\+ {
  padding-top: 5rem !important;
}

.pr\\+\\+ {
  padding-right: 5rem !important;
}

.pb\\+\\+ {
  padding-bottom: 5rem !important;
}

.pl\\+\\+ {
  padding-left: 5rem !important;
}

.pv\\+\\+ {
  padding-block: 5rem !important;
}

.ph\\+\\+ {
  padding-inline: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .m0\\(s\\) {
    margin: 0 !important;
  }

  .mt0\\(s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(s\\) {
    margin: .313rem !important;
  }

  .mt--\\(s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(s\\) {
    margin: .625rem !important;
  }

  .mt-\\(s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(s\\) {
    padding: 0 !important;
  }

  .pt0\\(s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(s\\) {
    padding: .313rem !important;
  }

  .pt--\\(s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(s\\) {
    padding: .625rem !important;
  }

  .pt-\\(s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .m0\\(m\\) {
    margin: 0 !important;
  }

  .mt0\\(m\\) {
    margin-top: 0 !important;
  }

  .mr0\\(m\\) {
    margin-right: 0 !important;
  }

  .mb0\\(m\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(m\\) {
    margin-left: 0 !important;
  }

  .mv0\\(m\\) {
    margin-block: 0 !important;
  }

  .mh0\\(m\\) {
    margin-inline: 0 !important;
  }

  .m--\\(m\\) {
    margin: .313rem !important;
  }

  .mt--\\(m\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(m\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(m\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(m\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(m\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(m\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(m\\) {
    margin: .625rem !important;
  }

  .mt-\\(m\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(m\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(m\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(m\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(m\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(m\\) {
    margin-inline: .625rem !important;
  }

  .m\\(m\\) {
    margin: 1.25rem !important;
  }

  .mt\\(m\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(m\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(m\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(m\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(m\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(m\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(m\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(m\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(m\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(m\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(m\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(m\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(m\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(m\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(m\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(m\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(m\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(m\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(m\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(m\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(m\\) {
    padding: 0 !important;
  }

  .pt0\\(m\\) {
    padding-top: 0 !important;
  }

  .pr0\\(m\\) {
    padding-right: 0 !important;
  }

  .pb0\\(m\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(m\\) {
    padding-left: 0 !important;
  }

  .pv0\\(m\\) {
    padding-block: 0 !important;
  }

  .ph0\\(m\\) {
    padding-inline: 0 !important;
  }

  .p--\\(m\\) {
    padding: .313rem !important;
  }

  .pt--\\(m\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(m\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(m\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(m\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(m\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(m\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(m\\) {
    padding: .625rem !important;
  }

  .pt-\\(m\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(m\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(m\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(m\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(m\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(m\\) {
    padding-inline: .625rem !important;
  }

  .p\\(m\\) {
    padding: 1.25rem !important;
  }

  .pt\\(m\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(m\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(m\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(m\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(m\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(m\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(m\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(m\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(m\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(m\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(m\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(m\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(m\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(m\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(m\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(m\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(m\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(m\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(m\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(m\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .m0\\(\\!s\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!s\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!s\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!s\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!s\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!s\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .m0\\(\\!l\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!l\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!l\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!l\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!l\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!l\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .m0\\(l\\) {
    margin: 0 !important;
  }

  .mt0\\(l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(l\\) {
    margin: .313rem !important;
  }

  .mt--\\(l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(l\\) {
    margin: .625rem !important;
  }

  .mt-\\(l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(l\\) {
    padding: 0 !important;
  }

  .pt0\\(l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(l\\) {
    padding: .313rem !important;
  }

  .pt--\\(l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(l\\) {
    padding: .625rem !important;
  }

  .pt-\\(l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .m0\\(xl\\) {
    margin: 0 !important;
  }

  .mt0\\(xl\\) {
    margin-top: 0 !important;
  }

  .mr0\\(xl\\) {
    margin-right: 0 !important;
  }

  .mb0\\(xl\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(xl\\) {
    margin-left: 0 !important;
  }

  .mv0\\(xl\\) {
    margin-block: 0 !important;
  }

  .mh0\\(xl\\) {
    margin-inline: 0 !important;
  }

  .m--\\(xl\\) {
    margin: .313rem !important;
  }

  .mt--\\(xl\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(xl\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(xl\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(xl\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(xl\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(xl\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(xl\\) {
    margin: .625rem !important;
  }

  .mt-\\(xl\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(xl\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(xl\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(xl\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(xl\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(xl\\) {
    margin-inline: .625rem !important;
  }

  .m\\(xl\\) {
    margin: 1.25rem !important;
  }

  .mt\\(xl\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(xl\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(xl\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(xl\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(xl\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(xl\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(xl\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(xl\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(xl\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(xl\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(xl\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(xl\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(xl\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(xl\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(xl\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(xl\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(xl\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(xl\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(xl\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(xl\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(xl\\) {
    padding: 0 !important;
  }

  .pt0\\(xl\\) {
    padding-top: 0 !important;
  }

  .pr0\\(xl\\) {
    padding-right: 0 !important;
  }

  .pb0\\(xl\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(xl\\) {
    padding-left: 0 !important;
  }

  .pv0\\(xl\\) {
    padding-block: 0 !important;
  }

  .ph0\\(xl\\) {
    padding-inline: 0 !important;
  }

  .p--\\(xl\\) {
    padding: .313rem !important;
  }

  .pt--\\(xl\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(xl\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(xl\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(xl\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(xl\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(xl\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(xl\\) {
    padding: .625rem !important;
  }

  .pt-\\(xl\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(xl\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(xl\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(xl\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(xl\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(xl\\) {
    padding-inline: .625rem !important;
  }

  .p\\(xl\\) {
    padding: 1.25rem !important;
  }

  .pt\\(xl\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(xl\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(xl\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(xl\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(xl\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(xl\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(xl\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(xl\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(xl\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(xl\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(xl\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(xl\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(xl\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(xl\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(xl\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(xl\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(xl\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(xl\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(xl\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(xl\\) {
    padding-inline: 5rem !important;
  }
}

.u-gap0 {
  gap: 0 !important;
}

.u-gap-- {
  gap: .313rem !important;
}

.u-gap- {
  gap: .625rem !important;
}

.u-gap {
  gap: 1.25rem !important;
}

.u-gap\\+ {
  gap: 2.5rem !important;
}

.u-gap\\+\\+ {
  gap: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .u-gap0\\(s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-gap0\\(m\\) {
    gap: 0 !important;
  }

  .u-gap--\\(m\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(m\\) {
    gap: .625rem !important;
  }

  .u-gap\\(m\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(m\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(m\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .u-gap0\\(\\!s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-gap0\\(\\!l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .u-gap0\\(l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-gap0\\(xl\\) {
    gap: 0 !important;
  }

  .u-gap--\\(xl\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(xl\\) {
    gap: .625rem !important;
  }

  .u-gap\\(xl\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(xl\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(xl\\) {
    gap: 5rem !important;
  }
}

.u-size-xl {
  font-size: var(--font-size-xl);
  line-height: var(--line-height-xl);
}

.u-size-l {
  font-size: var(--font-size-l);
  line-height: var(--line-height-l);
}

.u-size-m {
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
}

.u-size-s {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
}

.u-size-xs {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

.u-size-h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
  font-style: italic;
  font-weight: bold;
}

.u-size-h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
  font-style: italic;
  font-weight: bold;
}

.u-size-h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
  font-style: italic;
  font-weight: bold;
}

.u-size-h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
  font-weight: bold;
}

.u-size-h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
  font-weight: bold;
}

.u-size-h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  font-weight: bold;
}

@media screen and (width <= 46.9375em) {
  .u-size-xl\\(s\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(s\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(s\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(s\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(s\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(s\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(s\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(s\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(s\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(s\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(s\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-size-xl\\(m\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(m\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(m\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(m\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(m\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(m\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(m\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(m\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(m\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(m\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(m\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 47em), print {
  .u-size-xl\\(\\!s\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(\\!s\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(\\!s\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(\\!s\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(\\!s\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(\\!s\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(\\!s\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(\\!s\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(\\!s\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(\\!s\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(\\!s\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width <= 74.9375em) {
  .u-size-xl\\(\\!l\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(\\!l\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(\\!l\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(\\!l\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(\\!l\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(\\!l\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(\\!l\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(\\!l\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(\\!l\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(\\!l\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(\\!l\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 75em), print {
  .u-size-xl\\(l\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(l\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(l\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(l\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(l\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(l\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(l\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(l\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(l\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(l\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(l\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

@media screen and (width >= 90.0625em) {
  .u-size-xl\\(xl\\) {
    font-size: var(--font-size-xl);
    line-height: var(--line-height-xl);
  }

  .u-size-l\\(xl\\) {
    font-size: var(--font-size-l);
    line-height: var(--line-height-l);
  }

  .u-size-m\\(xl\\) {
    font-size: var(--font-size-m);
    line-height: var(--line-height-m);
  }

  .u-size-s\\(xl\\) {
    font-size: var(--font-size-s);
    line-height: var(--line-height-s);
  }

  .u-size-xs\\(xl\\) {
    font-size: var(--font-size-xs);
    line-height: var(--line-height-xs);
  }

  .u-size-h1\\(xl\\) {
    font-size: var(--font-size-h1);
    line-height: var(--line-height-h1);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h2\\(xl\\) {
    font-size: var(--font-size-h2);
    line-height: var(--line-height-h2);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h3\\(xl\\) {
    font-size: var(--font-size-h3);
    line-height: var(--line-height-h3);
    font-style: italic;
    font-weight: bold;
  }

  .u-size-h4\\(xl\\) {
    font-size: var(--font-size-h4);
    line-height: var(--line-height-h4);
    font-weight: bold;
  }

  .u-size-h5\\(xl\\) {
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h5);
    font-weight: bold;
  }

  .u-size-h6\\(xl\\) {
    font-size: var(--font-size-h6);
    line-height: var(--line-height-h6);
    font-weight: bold;
  }
}

.u-text-decoration--dashed-underline {
  text-underline-offset: .2rem;
  text-decoration-line: underline;
  text-decoration-style: dashed;
  text-decoration-thickness: from-font;
}

.u-text-decoration--none\\(hover\\):hover {
  text-decoration: none;
}

.u-display--inline {
  display: inline !important;
}

.u-display--inline-block {
  display: inline-block !important;
}

.u-display--block {
  display: block !important;
}

.u-display--flex {
  display: flex !important;
}

.u-display--inline-flex {
  display: inline-flex !important;
}

.u-display--none {
  display: none !important;
}

@media screen and (width <= 46.9375em) {
  .u-display--inline\\(s\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(s\\) {
    display: inline-block !important;
  }

  .u-display--block\\(s\\) {
    display: block !important;
  }

  .u-display--flex\\(s\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(s\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(s\\) {
    display: none !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-display--inline\\(m\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(m\\) {
    display: inline-block !important;
  }

  .u-display--block\\(m\\) {
    display: block !important;
  }

  .u-display--flex\\(m\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(m\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(m\\) {
    display: none !important;
  }
}

@media screen and (width >= 47em), print {
  .u-display--inline\\(\\!s\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(\\!s\\) {
    display: inline-block !important;
  }

  .u-display--block\\(\\!s\\) {
    display: block !important;
  }

  .u-display--flex\\(\\!s\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(\\!s\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(\\!s\\) {
    display: none !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-display--inline\\(\\!l\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(\\!l\\) {
    display: inline-block !important;
  }

  .u-display--block\\(\\!l\\) {
    display: block !important;
  }

  .u-display--flex\\(\\!l\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(\\!l\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(\\!l\\) {
    display: none !important;
  }
}

@media screen and (width >= 75em), print {
  .u-display--inline\\(l\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(l\\) {
    display: inline-block !important;
  }

  .u-display--block\\(l\\) {
    display: block !important;
  }

  .u-display--flex\\(l\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(l\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(l\\) {
    display: none !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-display--inline\\(xl\\) {
    display: inline !important;
  }

  .u-display--inline-block\\(xl\\) {
    display: inline-block !important;
  }

  .u-display--block\\(xl\\) {
    display: block !important;
  }

  .u-display--flex\\(xl\\) {
    display: flex !important;
  }

  .u-display--inline-flex\\(xl\\) {
    display: inline-flex !important;
  }

  .u-display--none\\(xl\\) {
    display: none !important;
  }
}

.u-display--flow-root {
  display: flow-root !important;
}

.u-position--absolute {
  position: absolute !important;
}

.u-position--relative {
  position: relative !important;
}

.u-position--fixed {
  position: fixed !important;
}

.u-position--static {
  position: static !important;
}

.u-text-align--left {
  text-align: left !important;
}

.u-text-align--right {
  text-align: right !important;
}

.u-text-align--center {
  text-align: center !important;
}

@media screen and (width <= 46.9375em) {
  .u-text-align--left\\(s\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(s\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(s\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-text-align--left\\(m\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(m\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(m\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 47em), print {
  .u-text-align--left\\(\\!s\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(\\!s\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(\\!s\\) {
    text-align: center !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-text-align--left\\(\\!l\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(\\!l\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(\\!l\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 75em), print {
  .u-text-align--left\\(l\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(l\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(l\\) {
    text-align: center !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-text-align--left\\(xl\\) {
    text-align: left !important;
  }

  .u-text-align--right\\(xl\\) {
    text-align: right !important;
  }

  .u-text-align--center\\(xl\\) {
    text-align: center !important;
  }
}

.u-font-weight--normal {
  font-weight: normal !important;
}

.u-font-weight--bold {
  font-weight: bold !important;
}

.u-font-style--normal {
  font-style: normal !important;
}

.u-font-style--italic {
  font-style: italic !important;
}

.u-text-decoration--underline {
  text-decoration: underline !important;
}

.u-text-decoration--line-through {
  text-decoration: line-through !important;
}

.u-text-decoration--none {
  text-decoration: none !important;
}

.u-border--none {
  border: none !important;
}

.u-border-color--inherit {
  border-color: inherit !important;
}

.u-line-height--normal {
  line-height: normal !important;
}

.u-white-space--nowrap {
  white-space: nowrap !important;
}

.u-white-space--normal {
  white-space: normal !important;
}

@media screen and (width <= 46.9375em) {
  .u-white-space--nowrap\\(s\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(s\\) {
    white-space: normal !important;
  }
}

@media screen and (width >= 47em), print {
  .u-white-space--nowrap\\(\\!s\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(\\!s\\) {
    white-space: normal !important;
  }
}

@media screen and (width >= 75em), print {
  .u-white-space--nowrap\\(l\\) {
    white-space: nowrap !important;
  }

  .u-white-space--normal\\(l\\) {
    white-space: normal !important;
  }
}

.u-opacity--0 {
  opacity: 0 !important;
}

.u-opacity--25 {
  opacity: .25 !important;
}

.u-opacity--50 {
  opacity: .5 !important;
}

.u-opacity--75 {
  opacity: .75 !important;
}

.u-opacity--90 {
  opacity: .9 !important;
}

.u-cursor--pointer {
  cursor: pointer !important;
}

.u-cursor--default {
  cursor: default !important;
}

.u-visibility--hidden {
  visibility: hidden !important;
}

.u-overflow--hidden {
  overflow: hidden !important;
}

.u-margin-left--auto {
  margin-left: auto !important;
}

@media screen and (width >= 47em), print {
  .u-margin-left--auto\\(\\!s\\) {
    margin-left: auto !important;
  }
}

.u-width--auto {
  width: auto !important;
}

.u-flex-wrap--nowrap {
  flex-wrap: nowrap !important;
}

.u-flex-wrap--wrap {
  flex-wrap: wrap !important;
}

@media screen and (width <= 46.9375em) {
  .u-flex-wrap--nowrap\\(s\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(s\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-flex-wrap--nowrap\\(m\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(m\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 47em), print {
  .u-flex-wrap--nowrap\\(\\!s\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(\\!s\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-flex-wrap--nowrap\\(\\!l\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(\\!l\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 75em), print {
  .u-flex-wrap--nowrap\\(l\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(l\\) {
    flex-wrap: wrap !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-flex-wrap--nowrap\\(xl\\) {
    flex-wrap: nowrap !important;
  }

  .u-flex-wrap--wrap\\(xl\\) {
    flex-wrap: wrap !important;
  }
}

.u-order---1 {
  order: -1 !important;
}

.u-order--1 {
  order: 1 !important;
}

@media screen and (width <= 46.9375em) {
  .u-order---1\\(s\\) {
    order: -1 !important;
  }

  .u-order--1\\(s\\) {
    order: 1 !important;
  }
}

@media screen and (width >= 47em), print {
  .u-order---1\\(\\!s\\) {
    order: -1 !important;
  }

  .u-order--1\\(\\!s\\) {
    order: 1 !important;
  }
}

.u-1\\/1 {
  width: 100% !important;
}

.u-1\\/2 {
  flex: none !important;
  width: 50% !important;
}

.u-2\\/2 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/3 {
  flex: none !important;
  width: 33.3333% !important;
}

.u-2\\/3 {
  flex: none !important;
  width: 66.6667% !important;
}

.u-3\\/3 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/4 {
  flex: none !important;
  width: 25% !important;
}

.u-2\\/4 {
  flex: none !important;
  width: 50% !important;
}

.u-3\\/4 {
  flex: none !important;
  width: 75% !important;
}

.u-4\\/4 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/5 {
  flex: none !important;
  width: 20% !important;
}

.u-2\\/5 {
  flex: none !important;
  width: 40% !important;
}

.u-3\\/5 {
  flex: none !important;
  width: 60% !important;
}

.u-4\\/5 {
  flex: none !important;
  width: 80% !important;
}

.u-5\\/5 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/10 {
  flex: none !important;
  width: 10% !important;
}

.u-2\\/10 {
  flex: none !important;
  width: 20% !important;
}

.u-3\\/10 {
  flex: none !important;
  width: 30% !important;
}

.u-4\\/10 {
  flex: none !important;
  width: 40% !important;
}

.u-5\\/10 {
  flex: none !important;
  width: 50% !important;
}

.u-6\\/10 {
  flex: none !important;
  width: 60% !important;
}

.u-7\\/10 {
  flex: none !important;
  width: 70% !important;
}

.u-8\\/10 {
  flex: none !important;
  width: 80% !important;
}

.u-9\\/10 {
  flex: none !important;
  width: 90% !important;
}

.u-10\\/10 {
  flex: none !important;
  width: 100% !important;
}

.u-1\\/24 {
  flex: none !important;
  width: 4.16667% !important;
}

.u-2\\/24 {
  flex: none !important;
  width: 8.33333% !important;
}

.u-3\\/24 {
  flex: none !important;
  width: 12.5% !important;
}

.u-4\\/24 {
  flex: none !important;
  width: 16.6667% !important;
}

.u-5\\/24 {
  flex: none !important;
  width: 20.8333% !important;
}

.u-6\\/24 {
  flex: none !important;
  width: 25% !important;
}

.u-7\\/24 {
  flex: none !important;
  width: 29.1667% !important;
}

.u-8\\/24 {
  flex: none !important;
  width: 33.3333% !important;
}

.u-9\\/24 {
  flex: none !important;
  width: 37.5% !important;
}

.u-10\\/24 {
  flex: none !important;
  width: 41.6667% !important;
}

.u-11\\/24 {
  flex: none !important;
  width: 45.8333% !important;
}

.u-12\\/24 {
  flex: none !important;
  width: 50% !important;
}

.u-13\\/24 {
  flex: none !important;
  width: 54.1667% !important;
}

.u-14\\/24 {
  flex: none !important;
  width: 58.3333% !important;
}

.u-15\\/24 {
  flex: none !important;
  width: 62.5% !important;
}

.u-16\\/24 {
  flex: none !important;
  width: 66.6667% !important;
}

.u-17\\/24 {
  flex: none !important;
  width: 70.8333% !important;
}

.u-18\\/24 {
  flex: none !important;
  width: 75% !important;
}

.u-19\\/24 {
  flex: none !important;
  width: 79.1667% !important;
}

.u-20\\/24 {
  flex: none !important;
  width: 83.3333% !important;
}

.u-21\\/24 {
  flex: none !important;
  width: 87.5% !important;
}

.u-22\\/24 {
  flex: none !important;
  width: 91.6667% !important;
}

.u-23\\/24 {
  flex: none !important;
  width: 95.8333% !important;
}

.u-24\\/24 {
  flex: none !important;
  width: 100% !important;
}

@media screen and (width <= 46.9375em) {
  .u-1\\/1\\(s\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(s\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(s\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(s\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(s\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(s\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(s\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(s\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(s\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(s\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(s\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(s\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(s\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(s\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(s\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(s\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(s\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(s\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(s\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(s\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(s\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(s\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(s\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(s\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-1\\/1\\(m\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(m\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(m\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(m\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(m\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(m\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(m\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(m\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(m\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(m\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(m\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(m\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(m\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(m\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(m\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(m\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(m\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(m\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(m\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(m\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(m\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(m\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(m\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(m\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(m\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(m\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(m\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(m\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(m\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(m\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(m\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(m\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(m\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(m\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(m\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(m\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(m\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(m\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(m\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(m\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(m\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 47em), print {
  .u-1\\/1\\(\\!s\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(\\!s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(\\!s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(\\!s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(\\!s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(\\!s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(\\!s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(\\!s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(\\!s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(\\!s\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(\\!s\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(\\!s\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(\\!s\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(\\!s\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(\\!s\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(\\!s\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(\\!s\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(\\!s\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(\\!s\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(\\!s\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(\\!s\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(\\!s\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(\\!s\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(\\!s\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(\\!s\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(\\!s\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(\\!s\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(\\!s\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(\\!s\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(\\!s\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(\\!s\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(\\!s\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(\\!s\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(\\!s\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(\\!s\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(\\!s\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(\\!s\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(\\!s\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(\\!s\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(\\!s\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(\\!s\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-1\\/1\\(\\!l\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(\\!l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(\\!l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(\\!l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(\\!l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(\\!l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(\\!l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(\\!l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(\\!l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(\\!l\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(\\!l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(\\!l\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(\\!l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(\\!l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(\\!l\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(\\!l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(\\!l\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(\\!l\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(\\!l\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(\\!l\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(\\!l\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(\\!l\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(\\!l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(\\!l\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(\\!l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(\\!l\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(\\!l\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(\\!l\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(\\!l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(\\!l\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(\\!l\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(\\!l\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(\\!l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(\\!l\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(\\!l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(\\!l\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(\\!l\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(\\!l\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(\\!l\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(\\!l\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(\\!l\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 75em), print {
  .u-1\\/1\\(l\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(l\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(l\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(l\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(l\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(l\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(l\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(l\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(l\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(l\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(l\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(l\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(l\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(l\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(l\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(l\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(l\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(l\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(l\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(l\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(l\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(l\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(l\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(l\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(l\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(l\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(l\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(l\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(l\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(l\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(l\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(l\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(l\\) {
    flex: none !important;
    width: 100% !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-1\\/1\\(xl\\) {
    width: 100% !important;
  }

  .u-1\\/2\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-2\\/2\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/3\\(xl\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-2\\/3\\(xl\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-3\\/3\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/4\\(xl\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-2\\/4\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-3\\/4\\(xl\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-4\\/4\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/5\\(xl\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-2\\/5\\(xl\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-3\\/5\\(xl\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-4\\/5\\(xl\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-5\\/5\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/10\\(xl\\) {
    flex: none !important;
    width: 10% !important;
  }

  .u-2\\/10\\(xl\\) {
    flex: none !important;
    width: 20% !important;
  }

  .u-3\\/10\\(xl\\) {
    flex: none !important;
    width: 30% !important;
  }

  .u-4\\/10\\(xl\\) {
    flex: none !important;
    width: 40% !important;
  }

  .u-5\\/10\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-6\\/10\\(xl\\) {
    flex: none !important;
    width: 60% !important;
  }

  .u-7\\/10\\(xl\\) {
    flex: none !important;
    width: 70% !important;
  }

  .u-8\\/10\\(xl\\) {
    flex: none !important;
    width: 80% !important;
  }

  .u-9\\/10\\(xl\\) {
    flex: none !important;
    width: 90% !important;
  }

  .u-10\\/10\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }

  .u-1\\/24\\(xl\\) {
    flex: none !important;
    width: 4.16667% !important;
  }

  .u-2\\/24\\(xl\\) {
    flex: none !important;
    width: 8.33333% !important;
  }

  .u-3\\/24\\(xl\\) {
    flex: none !important;
    width: 12.5% !important;
  }

  .u-4\\/24\\(xl\\) {
    flex: none !important;
    width: 16.6667% !important;
  }

  .u-5\\/24\\(xl\\) {
    flex: none !important;
    width: 20.8333% !important;
  }

  .u-6\\/24\\(xl\\) {
    flex: none !important;
    width: 25% !important;
  }

  .u-7\\/24\\(xl\\) {
    flex: none !important;
    width: 29.1667% !important;
  }

  .u-8\\/24\\(xl\\) {
    flex: none !important;
    width: 33.3333% !important;
  }

  .u-9\\/24\\(xl\\) {
    flex: none !important;
    width: 37.5% !important;
  }

  .u-10\\/24\\(xl\\) {
    flex: none !important;
    width: 41.6667% !important;
  }

  .u-11\\/24\\(xl\\) {
    flex: none !important;
    width: 45.8333% !important;
  }

  .u-12\\/24\\(xl\\) {
    flex: none !important;
    width: 50% !important;
  }

  .u-13\\/24\\(xl\\) {
    flex: none !important;
    width: 54.1667% !important;
  }

  .u-14\\/24\\(xl\\) {
    flex: none !important;
    width: 58.3333% !important;
  }

  .u-15\\/24\\(xl\\) {
    flex: none !important;
    width: 62.5% !important;
  }

  .u-16\\/24\\(xl\\) {
    flex: none !important;
    width: 66.6667% !important;
  }

  .u-17\\/24\\(xl\\) {
    flex: none !important;
    width: 70.8333% !important;
  }

  .u-18\\/24\\(xl\\) {
    flex: none !important;
    width: 75% !important;
  }

  .u-19\\/24\\(xl\\) {
    flex: none !important;
    width: 79.1667% !important;
  }

  .u-20\\/24\\(xl\\) {
    flex: none !important;
    width: 83.3333% !important;
  }

  .u-21\\/24\\(xl\\) {
    flex: none !important;
    width: 87.5% !important;
  }

  .u-22\\/24\\(xl\\) {
    flex: none !important;
    width: 91.6667% !important;
  }

  .u-23\\/24\\(xl\\) {
    flex: none !important;
    width: 95.8333% !important;
  }

  .u-24\\/24\\(xl\\) {
    flex: none !important;
    width: 100% !important;
  }
}

.c-person-selector {
  border-radius: var(--border-radius-m);
  border: 1px solid #f1f1f1;
  flex: 60%;
  height: 50px;
  padding-inline: 5px;
  display: flex;
}

.c-person-selector__wrapper {
  margin-bottom: 5px;
  display: flex;
}

.c-person-selector__label {
  text-align: right;
  flex-direction: column;
  flex: 40%;
  display: flex;
}

.c-person-selector__person {
  text-align: center;
  flex: auto;
  align-self: center;
  padding: 0;
  display: inline-block;
}

.c-person-selector__person svg path, .c-person-selector__person:hover ~ .c-person-selector__person svg path {
  fill: var(--color-grey--x-light);
}

.c-person-selector__person-selected svg path, .c-person-selector__person:has( ~ .c-person-selector__person-selected) svg path, .c-person-selector__person:hover svg path, .c-person-selector__person:has( ~ :hover) svg path {
  fill: var(--color-black);
}

.c-person-selector__label--person, .c-person-selector__label--gas, .c-person-selector__label--electricity {
  flex: auto;
}

.c-person-selector__label--electricity svg path {
  fill: var(--color-grey);
}
`;


class $4be2fd52edaf76ec$var$BCUsageWidget extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.lowUsageInputRef = (0, $c2866c8c0be843b6$export$7d1e3a5e95ceca43)();
        this.highUsageInputRef = (0, $c2866c8c0be843b6$export$7d1e3a5e95ceca43)();
        this.totalInputRef = (0, $c2866c8c0be843b6$export$7d1e3a5e95ceca43)();
        this.meterTypeRef = (0, $c2866c8c0be843b6$export$7d1e3a5e95ceca43)();
        this.selectedPersons = 2;
        this.hoveringPersons = null;
        this.optionvalues = [];
        this.preselectedValue = null;
        this.hiddenHighUsageInput = document.getElementById("hiddenHighUsageInput");
        this.hiddenLowUsageInput = document.getElementById("hiddenLowUsageInput");
        this.hiddenUsage = document.getElementById("hiddenUsageInput");
        this.hiddenMeterType = document.getElementById("hiddenMeterType");
    }
    connectedCallback() {
        super.connectedCallback();
        this.optionvalues = this.showGas ? this.optionvaluesGas : this.optionvaluesElectricity;
        if (this.usageSelection) this.showGuesstimate = this.usageSelection == "guesstimate";
        else this.showGuesstimate = this.showGuesstimateToggle;
        if (this.optionvalues && this.preselectedValue) {
            this.usage = this.preselectedValue;
            this.hiddenUsage.value = this.preselectedValue;
            if (this.optionvalues.indexOf(this.preselectedValue) == -1) {
                let selectedPersons = 1;
                this.optionvalues.forEach((value, index)=>{
                    if (value <= this.preselectedValue) selectedPersons = index + 1;
                });
                this.selectedPersons = selectedPersons;
            } else this.selectedPersons = this.optionvalues.indexOf(this.preselectedValue) + 1;
        } else if (this.optionvalues && this.showGuesstimateToggle) {
            const selectedUsage = this.optionvalues[this.selectedPersons - 1];
            this.usage = selectedUsage;
            this.hiddenUsage.value = selectedUsage;
            if (this.showSingleDualToggle) this._setSplitUsage(selectedUsage);
        } else {
            if (this.usage == undefined) {
                this.usage = "";
                this.hiddenUsage.value = "";
                if (this.highUsage != undefined && this.lowUsage != undefined) {
                    this.usage = this.lowUsage + this.highUsage;
                    this.hiddenUsage.value = this.usage;
                }
            } else this.hiddenUsage.value = this.usage;
            if (this.highUsage == undefined) {
                this.highUsage = "";
                this.hiddenHighUsageInput.value = "";
            } else this.hiddenHighUsageInput.value = this.highUsage;
            if (this.lowUsage == undefined) {
                this.lowUsage = "";
                this.hiddenLowUsageInput.value = "";
            } else this.hiddenLowUsageInput.value = this.lowUsage;
        }
        if (this.showSingleDualToggle) {
            this.meterType = this.showDualUsage ? "dual" : "single";
            this.hiddenMeterType.value = this.meterType;
        }
    }
    _handleSelection(person) {
        this.selectedPersons = person;
        const selectedUsage = this.optionvalues[person - 1];
        this.usage = selectedUsage;
        this.hiddenUsage.value = selectedUsage;
        if (this.showSingleDualToggle) this._setSplitUsage(selectedUsage);
        this.hiddenUsage.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
    _usageInputCheck(inputRef) {
        let inputElement = inputRef.value;
        let usage = inputElement.value;
        usage = usage.replace(/[^0-9]/g, ""); // Remove non-numeric characters
        inputElement.value = usage; // Update the input value
    }
    _updateSingleUsage() {
        let usage = this.totalInputRef.value.value;
        this.hiddenUsage.value = usage;
        if (this.showSingleDualToggle) this._setSplitUsage(usage);
        this.hiddenUsage.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
    _updateDualUsage() {
        let highUsage = this.highUsageInputRef.value.value;
        let lowUsage = this.lowUsageInputRef.value.value;
        this.hiddenHighUsageInput.value = highUsage;
        this.hiddenLowUsageInput.value = lowUsage;
        let usage = parseInt(highUsage) + parseInt(lowUsage);
        if (isNaN(usage)) usage = "";
        this.usage = usage;
        this.hiddenUsage.value = usage;
        if (usage != "") this.hiddenUsage.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
    _setSplitUsage(selectedUsage) {
        if (selectedUsage) {
            let tenthUsage = Math.floor(selectedUsage / 10);
            this.usage = selectedUsage;
            this.highUsage = tenthUsage * 6;
            this.lowUsage = tenthUsage * 4;
            this.hiddenUsage.value = this.usage;
            this.hiddenHighUsageInput.value = this.highUsage;
            this.hiddenLowUsageInput.value = this.lowUsage;
            this.hiddenUsage.dispatchEvent(new Event("change", {
                bubbles: true
            }));
        }
    }
    _toggleGuesstimate() {
        this.showGuesstimate = !this.showGuesstimate;
        document.getElementById("usageSelection").value = this.showGuesstimate ? "guesstimate" : "own";
    }
    toggleSingleDual() {
        this.showDualUsage = this.meterTypeRef.value.checked;
        hiddenMeterType.value = this.showDualUsage ? "dual" : "single";
    }
    render() {
        this.optionvalues = this.showGas ? this.optionvaluesGas : this.optionvaluesElectricity;
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
      <div class="u-font-weight--bold">Jährlicher ${this.showGas ? "Gasverbrauch" : "Stromverbrauch"}</div>
      <div>${this.showSingleDualToggle ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`${this.renderSingleDualToggle(this.showDualUsage)}` : (0, $bd6886d5707a45a8$export$45b790e32b2810ee)}</div>
      <div>${this.renderSelectionType()}</div>
      <div>${this.showGuesstimateToggle ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`${this.renderGuesstimateToggle()}` : (0, $bd6886d5707a45a8$export$45b790e32b2810ee)}</div>
    `;
    }
    renderGuesstimateToggle() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` <button @click="${()=>this._toggleGuesstimate()}" class="c-link c-link--accent">${this.showGuesstimate ? "Eigenen Verbrauch eingeben" : "Einen Sch\xe4tzwert machen"}</button>`;
    }
    renderSingleDualToggle(showDualUsage) {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
      <div class="mb--">
        <input class="c-inputfields__input--checkbox" id="meterType" type="checkbox" ?checked=${showDualUsage} @change=${()=>this.toggleSingleDual()} ${(0, $c2866c8c0be843b6$export$eff4d24c3ff7876e)(this.meterTypeRef)} />
        <label for="meterType" class="c-inputfields__label"> Ich hab ein Doppeltarifzähler </label>
      </div>
    `;
    }
    renderSelectionType() {
        if (this.showGuesstimate) return this.renderPersons();
        else {
            if (this.showDualUsage) return this.renderDoubleUsageInputs();
            else return this.renderSingleUsageInput();
        }
    }
    renderPersons() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<div class="c-person-selector__wrapper">
      ${this.renderPersonCountSelector()}
      <div class="c-person-selector__label">
        <span class="c-person-selector__label--person"> ${this.selectedPersons} ${this.selectedPersons == 1 ? "Person" : " Personen"}</span>
        ${!this.showGas ? (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<span class="c-person-selector__label--electricity" @click="${()=>this._toggleGuesstimate()}"> ${this.renderBolt()} ${this.optionvalues[this.selectedPersons - 1]} kWh </span>` : (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<span class="c-person-selector__label--gas" @click="${()=>this._toggleGuesstimate()}"> ${this.renderFlame()} ${this.optionvalues[this.selectedPersons - 1]} kWh </span>`}
      </div>
    </div>`;
    }
    renderDoubleUsageInputs() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` <div class="layout mb--">
      <div class="layout__item u-1/2">
        <label for="usageHigh" class="u-size-s">Verbrauch HT</label>
        <div class="c-inputwidget__usage">
          <input type="text" class="c-inputwidget__electricity-input" maxlength="5" @keyup="${()=>this._usageInputCheck(this.highUsageInputRef)}" @change="${()=>this._updateDualUsage()}" .value=${String(this.highUsage)} ${(0, $c2866c8c0be843b6$export$eff4d24c3ff7876e)(this.highUsageInputRef)} name="usageHigh" id="usageHigh" />
          <span class="c-inputwidget__usage-unit">kWh</span>
        </div>
      </div>

      <div class="layout__item u-1/2">
        <label for="usageLow" class="u-size-s">Verbrauch NT</label>
        <div class="c-inputwidget__usage">
          <input type="text" class="c-inputwidget__electricity-input" maxlength="5" @keyup="${()=>this._usageInputCheck(this.lowUsageInputRef)}" @change="${()=>this._updateDualUsage()}" .value=${String(this.lowUsage)} ${(0, $c2866c8c0be843b6$export$eff4d24c3ff7876e)(this.lowUsageInputRef)} name="usageLow" id="usageLow" />
          <span class="c-inputwidget__usage-unit">kWh</span>
        </div>
      </div>
    </div>`;
    }
    renderSingleUsageInput() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` <div class="u-display--flex u-gap mb--">
      <div class="c-inputwidget__usage">
        <input type="text" class="${this.showGas ? "c-inputwidget__gas-input" : "c-inputwidget__electricity-input"}" maxlength="5" @keyup="${()=>this._usageInputCheck(this.totalInputRef)}" @change="${()=>this._updateSingleUsage()}" .value=${String(this.usage)} ${(0, $c2866c8c0be843b6$export$eff4d24c3ff7876e)(this.totalInputRef)} name="usage" id="usage" />
        <span class="c-inputwidget__usage-unit">kWh</span>
      </div>
    </div>`;
    }
    renderPersonCountSelector() {
        const personCount = Array.from({
            length: 5
        }, (_, i)=>i + 1);
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` <div class="c-person-selector">
      ${personCount.map((person)=>{
            const isSelectedClass = person <= this.selectedPersons ? "c-person-selector__person-selected" : "";
            return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<button type="button"
            @click="${()=>this._handleSelection(person)}"
            class="
            c-person-selector__person
            ${isSelectedClass}"
            data-person=${person}
            aria-label="Select ${isSelectedClass} person"
            >${this.renderPerson(person)}
          </button></div></div>`;
        })}
    </div>`;
    }
    renderFlame() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` <svg width="10" height="15" viewBox="0 0 10 15" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.013 0S4.771 3.251 2.5 5.558C.481 7.195.158 8.065.033 9.299c-.126 1.24.01 3.636 2.283 5.271 0 0-.817-1.99 1.196-3.623C5.43 9.389 5.194 8.282 5.165 8.18c.023.086.478 1.713 1.474 2.638 1.021.949.872 2.627-.094 4.182 0 0 3.14-2.023 3.42-4.735.128-1.262-.102-2.582-.53-3.84C8.365 3.276 6.057.511 5.013 0z" fill="#9b9b9b" class="u-svg-fill" />
    </svg>`;
    }
    renderBolt() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)` <svg width="9" height="15" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.477 5.145A.25.25 0 0 0 8.25 5H5.288L8.21.384A.25.25 0 0 0 8.001 0H4a.25.25 0 0 0-.225.138l-3.75 7.5A.25.25 0 0 0 .25 8h2.57l-2.8 6.653a.25.25 0 0 0 .421.258l8-9.5a.25.25 0 0 0 .036-.266z" fill="#9b9b9b" />
    </svg>`;
    }
    renderPerson(person) {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`<svg width="13" height="30" data-person=${person} viewBox="0 0 13 30" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.513 16.105c.19.876-.314 1.592-1.123 1.592H9.926l-.134 1.625-.718 9.054C9.003 29.269 8.332 30 7.58 30H4.852c-.752 0-1.424-.731-1.495-1.624l-.718-9.054-.137-1.625H1.103c-.774 0-1.252-.716-1.061-1.592l1.45-6.683c.19-.876 1.079-1.592 1.975-1.592h5.621c.897 0 1.785.716 1.975 1.592l1.45 6.683L6.84 1.921m2.687 1.33a3.25 3.25 0 1 0-6.5-.001 3.25 3.25 0 0 0 6.5 0"></path>
    </svg>`;
    }
}
$4be2fd52edaf76ec$var$BCUsageWidget.properties = {
    optionvaluesGas: {
        type: Array,
        reflect: true,
        attribute: "data-option-values-gas"
    },
    optionvaluesElectricity: {
        type: Array,
        reflect: true,
        attribute: "data-option-values-electricity"
    },
    preselectedValue: {
        type: Number,
        reflect: true,
        attribute: "data-preselected-value"
    },
    selectedPersons: {
        type: Number,
        reflect: true,
        attribute: "data-selected-persons"
    },
    showGuesstimateToggle: {
        type: Boolean,
        reflect: true,
        default: false,
        attribute: "data-show-guesstimate-toggle"
    },
    showGuesstimate: {
        type: Boolean,
        reflect: true,
        default: true
    },
    usageSelection: {
        type: String,
        reflect: true,
        default: "guesstimate",
        attribute: "data-usage-selection"
    },
    showSingleDualToggle: {
        type: Boolean,
        reflect: true,
        default: false,
        attribute: "data-show-single-dual-toggle"
    },
    showGas: {
        type: Boolean,
        reflect: true,
        default: false,
        attribute: "data-show-gas"
    },
    lowUsage: {
        type: Number,
        reflect: true,
        default: 0,
        attribute: "data-low-usage"
    },
    highUsage: {
        type: Number,
        reflect: true,
        default: 0,
        attribute: "data-high-usage"
    },
    hoveringPersons: {
        state: true
    },
    showDualUsage: {
        type: Boolean,
        reflect: true,
        default: false,
        attribute: "data-show-dual-usage"
    },
    hiddenUsage: {
        state: true
    },
    hiddenHighUsageInput: {
        state: true
    },
    hiddenLowUsageInput: {
        state: true
    }
};
$4be2fd52edaf76ec$var$BCUsageWidget.styles = [
    (0, $e557ee19ae2c1966$export$2a938b38c17da265)
];
const $4be2fd52edaf76ec$export$2dcf7e0dfd976c87 = ()=>{
    if (!window.customElements.get("bc-person-selector")) customElements.define("bc-usage-widget", $4be2fd52edaf76ec$var$BCUsageWidget);
};





const $019808f85888b105$export$68cf25e5a1bc1124 = (0, $2ebca2d23ae8704c$export$dbf350e5966cf602)`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

.layout {
  flex-wrap: wrap;
  margin: 0 0 0 -20px;
  padding: 0;
  list-style: none;
  display: flex;
}

@media screen and (width >= 47em), print {
  .layout--nowrap {
    flex-wrap: nowrap;
  }
}

.layout--rev {
  flex-direction: row-reverse;
}

.layout--middle {
  align-items: center;
}

.layout--spaced {
  justify-content: space-between;
}

.layout--center {
  justify-content: center;
}

.layout__item {
  width: 100%;
  padding-left: 20px;
}

.layout--auto > .layout__item {
  flex-basis: content;
}

.layout--flush {
  margin-left: 0;
}

.layout--flush > .layout__item {
  padding-left: 0;
}

.layout--small {
  margin-left: -10px;
}

.layout--small > .layout__item {
  padding-left: 10px;
}

.c-button {
  --button-background-color: var(--color-brand);
  --button-text-color: var(--color-white);
  font-size: var(--font-size-button);
  line-height: var(--line-height-button);
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  color: var(--button-text-color);
  background-color: var(--button-background-color);
  border-radius: var(--border-radius-m);
  transition-property: opacity, transform, background-color, color;
  transition-duration: var(--duration-fast);
  transition-timing-function: var(--swift-ease-in-timing-function);
  border: none;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  display: inline-flex;
  position: relative;
  overflow: hidden;
  transform: translateZ(0);
}

.c-button:not(.c-icon-button) {
  padding: calc(1.5 * var(--spacing-)) var(--spacing);
}

.c-button:hover {
  text-decoration: none;
}

.c-button[hidden] {
  display: none;
}

.c-button:before {
  content: "";
  z-index: -1;
  background: var(--color-black);
  opacity: 0;
  transform-origin: 50%;
  transition-property: opacity, transform, background-color, color;
  transition-duration: var(--duration-fast);
  transition-timing-function: var(--swift-ease-in-timing-function);
  border-radius: var(--button-border-radius);
  position: absolute;
  inset: 0;
  transform: scale(.5);
}

.c-button:hover:before, .c-button:active:before {
  opacity: .15;
  transform: scale(1.2);
}

.c-button--small {
  font-size: var(--font-size-m);
  line-height: var(--line-height-s);
  border-radius: var(--border-radius-s);
  padding-top: var(--spacing--) !important;
  padding-bottom: var(--spacing--) !important;
}

.c-button--large {
  padding-top: var(--spacing) !important;
  padding-bottom: var(--spacing) !important;
}

.c-button--support {
  --button-background-color: var(--color-brand--support);
  --button-text-color: var(--color-white);
}

.c-button--accent {
  --button-background-color: var(--color-brand--accent);
  --button-text-color: var(--color-white);
}

.c-button--grey {
  --button-background-color: var(--color-grey--light);
  --button-text-color: var(--color-grey--dark);
}

.c-button--white {
  --button-background-color: var(--color-white);
  --button-text-color: var(--color-grey--dark);
  fill: var(--color-grey--dark);
}

.c-button--white:before {
  background-color: #0000;
}

.c-button--white:hover {
  background-color: hsl(from var(--color-white) h s l / .9);
}

.c-button--ghost {
  --button-background-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-color: inherit;
}

.c-button--ghost:before {
  background-color: var(--color-white);
}

.c-button--disabled, .c-button[disabled] {
  cursor: default;
  --button-background-color: var(--color-grey--light);
}

.c-button--disabled:before, .c-button[disabled]:before {
  display: none;
}

.c-button--fullwidth {
  width: 100%;
}

@media screen and (width >= 47em), print {
  .c-inputfields__input--s, .c-inputfields__input--m {
    width: 120px !important;
  }

  .c-inputfields__input--s.c-inputfields__input--inline, .c-inputfields__input--m.c-inputfields__input--inline {
    width: 110px !important;
  }

  .c-inputfields__input--l, .c-inputfields__input--xl {
    width: 320px !important;
  }

  .c-inputfields__input--l.c-inputfields__input--inline, .c-inputfields__input--xl.c-inputfields__input--inline {
    width: 200px !important;
  }
}

@media screen and (width <= 46.9375em) {
  .c-inputfields__input--s.c-inputfields__input--inline, .c-inputfields__input--m.c-inputfields__input--inline {
    width: 36vw !important;
  }

  .c-inputfields__input--l.c-inputfields__input--inline, .c-inputfields__input--xl.c-inputfields__input--inline {
    width: 48vw !important;
  }
}

.c-inputfields__label {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  font-style: normal;
}

.c-inputfields__label--error {
  color: var(--color-status--red);
}

.c-inputfields__label--error input[type="text"], .c-inputfields__label--error input[type="email"], .c-inputfields__label--error input[type="password"], .c-inputfields__label--error input[type="search"], .c-inputfields__label--error input[type="color"], .c-inputfields__label--error input[type="date"], .c-inputfields__label--error input[type="datetime-local"], .c-inputfields__label--error input[type="month"], .c-inputfields__label--error input[type="number"], .c-inputfields__label--error input[type="tel"], .c-inputfields__label--error input[type="time"], .c-inputfields__label--error input[type="url"], .c-inputfields__label--error input[type="week"], .c-inputfields__label--error input[list], .c-inputfields__label--error input[type="file"], .c-inputfields__label--error select, .c-inputfields__label--error textarea {
  border: 1px solid var(--color-status--red);
}

.c-inputfields__input--radio, .c-inputfields__input--checkbox {
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: none !important;
  width: .01em !important;
  height: .01em !important;
  padding: 0 !important;
  position: absolute !important;
  overflow: hidden !important;
}

.c-inputfields__input--radio ~ .c-inputfields__label, .c-inputfields__input--checkbox ~ .c-inputfields__label {
  padding-left: 35px;
  display: inline-block;
  position: relative;
}

.c-inputfields__input--radio ~ .c-inputfields__label:before, .c-inputfields__input--checkbox ~ .c-inputfields__label:before {
  content: "";
  background-color: var(--color-white);
  border: 1px solid var(--color-grey--light);
  width: 20px;
  height: 20px;
  position: absolute;
  top: -1px;
  left: 0;
}

.c-inputfields__input--radio ~ .c-inputfields__label:after, .c-inputfields__input--checkbox ~ .c-inputfields__label:after {
  content: "";
  opacity: 0;
  width: 20px;
  height: 20px;
  transition: all .1s var(--swift-ease-in-out-timing-function);
  position: absolute;
  top: -1px;
  left: 0;
  transform: scale(0);
}

.c-inputfields__input--radio ~ .c-inputfields__label--tight, .c-inputfields__input--checkbox ~ .c-inputfields__label--tight {
  padding-left: 30px;
}

.c-inputfields__input--radio ~ .c-inputfields__label--small:before, .c-inputfields__input--checkbox ~ .c-inputfields__label--small:before {
  border-color: var(--color-grey);
  transform: scale(.7);
}

.c-inputfields__input--radio ~ .c-inputfields__label--block, .c-inputfields__input--checkbox ~ .c-inputfields__label--block {
  display: block;
}

.c-inputfields__input--radio:checked ~ .c-inputfields__label:after, .c-inputfields__input--checkbox:checked ~ .c-inputfields__label:after {
  opacity: 1;
  transform: scale(1);
}

.c-inputfields__input--radio:checked ~ .c-inputfields__label--small:after, .c-inputfields__input--checkbox:checked ~ .c-inputfields__label--small:after {
  transform: scale(.7);
}

.c-inputfields__input--radio:focus ~ .c-inputfields__label:before, .c-inputfields__input--checkbox:focus ~ .c-inputfields__label:before {
  box-shadow: 0 0 4px 0 hsl(from var(--color-brand--accent) h s l / .3);
  border-color: hsl(from var(--color-brand--accent) h s l / .2);
}

.c-inputfields__input--radio:disabled, .c-inputfields__input--checkbox:disabled, .c-inputfields__input--radio:disabled + .c-inputfields__label, .c-inputfields__input--checkbox:disabled + .c-inputfields__label {
  opacity: .5;
}

.c-inputfields__input--radio ~ .c-inputfields__label:before {
  border-radius: var(--border-radius-xl);
}

.c-inputfields__input--radio ~ .c-inputfields__label:after {
  border-radius: var(--border-radius-xl);
  background-color: var(--color-brand--accent);
}

.c-inputfields__input--radio ~ .c-inputfields__label--accent:after {
  background-color: var(--color-brand--accent);
}

.c-inputfields__input--radio:checked ~ .c-inputfields__label:after {
  transform: scale(.6);
}

.c-inputfields__input--checkbox ~ .c-inputfields__label:before {
  border-radius: var(--border-radius-xs);
}

.c-inputfields__input--checkbox ~ .c-inputfields__label:after {
  background: url("data:image/svg+xml,%3Csvg width='14' height='12' viewBox='0 0 14 12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.14.5L4.578 8.59 2.419 6.187c-.471-.52-1.364-.595-1.918-.153a1.3 1.3 0 0 0-.496.914c-.03.358.087.705.33.975l3.255 3.624c.263.288.643.454 1.04.454a1.406 1.406 0 0 0 1.087-.508l7.593-9.361c.229-.282.327-.634.28-.987a1.297 1.297 0 0 0-.541-.89C12.464-.167 11.585-.05 11.14.5z' fill='%23469de6' fill-rule='evenodd'/%3E%3C/svg%3E") center no-repeat;
}

.c-inputfields__input--checkbox:not(:checked) ~ .c-inputfields__label--button:hover {
  border-color: hsl(from var(--color-brand--accent) h s l / .5);
  box-shadow: 0 2px 4px 0 hsl(from var(--color-brand--accent) h s l / .1);
}

.c-inputfields__input--checkbox:not(:checked) ~ .c-inputfields__label--button:hover:after {
  opacity: .5;
  transform: scale(1);
}

.c-select {
  background-image: url("data:image/svg+xml,%3Csvg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_184_4)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 7H0L4 12L8 7ZM8 5H0L4 0L8 5Z' fill='%233D3D3D'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_184_4'%3E%3Crect width='8' height='12' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
  background-position: right .5em top 50%;
  background-repeat: no-repeat;
}

@media screen and (width >= 47em), print {
  .c-form-sidebar--sticky {
    position: sticky;
    top: 20px;
  }
}

.c-form-error {
  scroll-margin-top: 40px;
}

.c-form-error:is(input), .c-form-error:is(select) {
  border: 1px solid var(--color-status--red);
}

.c-form-error:not(select, input) {
  color: var(--color-status--red);
}

.m0 {
  margin: 0 !important;
}

.mt0 {
  margin-top: 0 !important;
}

.mr0 {
  margin-right: 0 !important;
}

.mb0 {
  margin-bottom: 0 !important;
}

.ml0 {
  margin-left: 0 !important;
}

.mv0 {
  margin-block: 0 !important;
}

.mh0 {
  margin-inline: 0 !important;
}

.m-- {
  margin: .313rem !important;
}

.mt-- {
  margin-top: .313rem !important;
}

.mr-- {
  margin-right: .313rem !important;
}

.mb-- {
  margin-bottom: .313rem !important;
}

.ml-- {
  margin-left: .313rem !important;
}

.mv-- {
  margin-block: .313rem !important;
}

.mh-- {
  margin-inline: .313rem !important;
}

.m- {
  margin: .625rem !important;
}

.mt- {
  margin-top: .625rem !important;
}

.mr- {
  margin-right: .625rem !important;
}

.mb- {
  margin-bottom: .625rem !important;
}

.ml- {
  margin-left: .625rem !important;
}

.mv- {
  margin-block: .625rem !important;
}

.mh- {
  margin-inline: .625rem !important;
}

.m {
  margin: 1.25rem !important;
}

.mt {
  margin-top: 1.25rem !important;
}

.mr {
  margin-right: 1.25rem !important;
}

.mb {
  margin-bottom: 1.25rem !important;
}

.ml {
  margin-left: 1.25rem !important;
}

.mv {
  margin-block: 1.25rem !important;
}

.mh {
  margin-inline: 1.25rem !important;
}

.m\\+ {
  margin: 2.5rem !important;
}

.mt\\+ {
  margin-top: 2.5rem !important;
}

.mr\\+ {
  margin-right: 2.5rem !important;
}

.mb\\+ {
  margin-bottom: 2.5rem !important;
}

.ml\\+ {
  margin-left: 2.5rem !important;
}

.mv\\+ {
  margin-block: 2.5rem !important;
}

.mh\\+ {
  margin-inline: 2.5rem !important;
}

.m\\+\\+ {
  margin: 5rem !important;
}

.mt\\+\\+ {
  margin-top: 5rem !important;
}

.mr\\+\\+ {
  margin-right: 5rem !important;
}

.mb\\+\\+ {
  margin-bottom: 5rem !important;
}

.ml\\+\\+ {
  margin-left: 5rem !important;
}

.mv\\+\\+ {
  margin-block: 5rem !important;
}

.mh\\+\\+ {
  margin-inline: 5rem !important;
}

.p0 {
  padding: 0 !important;
}

.pt0 {
  padding-top: 0 !important;
}

.pr0 {
  padding-right: 0 !important;
}

.pb0 {
  padding-bottom: 0 !important;
}

.pl0 {
  padding-left: 0 !important;
}

.pv0 {
  padding-block: 0 !important;
}

.ph0 {
  padding-inline: 0 !important;
}

.p-- {
  padding: .313rem !important;
}

.pt-- {
  padding-top: .313rem !important;
}

.pr-- {
  padding-right: .313rem !important;
}

.pb-- {
  padding-bottom: .313rem !important;
}

.pl-- {
  padding-left: .313rem !important;
}

.pv-- {
  padding-block: .313rem !important;
}

.ph-- {
  padding-inline: .313rem !important;
}

.p- {
  padding: .625rem !important;
}

.pt- {
  padding-top: .625rem !important;
}

.pr- {
  padding-right: .625rem !important;
}

.pb- {
  padding-bottom: .625rem !important;
}

.pl- {
  padding-left: .625rem !important;
}

.pv- {
  padding-block: .625rem !important;
}

.ph- {
  padding-inline: .625rem !important;
}

.p {
  padding: 1.25rem !important;
}

.pt {
  padding-top: 1.25rem !important;
}

.pr {
  padding-right: 1.25rem !important;
}

.pb {
  padding-bottom: 1.25rem !important;
}

.pl {
  padding-left: 1.25rem !important;
}

.pv {
  padding-block: 1.25rem !important;
}

.ph {
  padding-inline: 1.25rem !important;
}

.p\\+ {
  padding: 2.5rem !important;
}

.pt\\+ {
  padding-top: 2.5rem !important;
}

.pr\\+ {
  padding-right: 2.5rem !important;
}

.pb\\+ {
  padding-bottom: 2.5rem !important;
}

.pl\\+ {
  padding-left: 2.5rem !important;
}

.pv\\+ {
  padding-block: 2.5rem !important;
}

.ph\\+ {
  padding-inline: 2.5rem !important;
}

.p\\+\\+ {
  padding: 5rem !important;
}

.pt\\+\\+ {
  padding-top: 5rem !important;
}

.pr\\+\\+ {
  padding-right: 5rem !important;
}

.pb\\+\\+ {
  padding-bottom: 5rem !important;
}

.pl\\+\\+ {
  padding-left: 5rem !important;
}

.pv\\+\\+ {
  padding-block: 5rem !important;
}

.ph\\+\\+ {
  padding-inline: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .m0\\(s\\) {
    margin: 0 !important;
  }

  .mt0\\(s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(s\\) {
    margin: .313rem !important;
  }

  .mt--\\(s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(s\\) {
    margin: .625rem !important;
  }

  .mt-\\(s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(s\\) {
    padding: 0 !important;
  }

  .pt0\\(s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(s\\) {
    padding: .313rem !important;
  }

  .pt--\\(s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(s\\) {
    padding: .625rem !important;
  }

  .pt-\\(s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .m0\\(m\\) {
    margin: 0 !important;
  }

  .mt0\\(m\\) {
    margin-top: 0 !important;
  }

  .mr0\\(m\\) {
    margin-right: 0 !important;
  }

  .mb0\\(m\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(m\\) {
    margin-left: 0 !important;
  }

  .mv0\\(m\\) {
    margin-block: 0 !important;
  }

  .mh0\\(m\\) {
    margin-inline: 0 !important;
  }

  .m--\\(m\\) {
    margin: .313rem !important;
  }

  .mt--\\(m\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(m\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(m\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(m\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(m\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(m\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(m\\) {
    margin: .625rem !important;
  }

  .mt-\\(m\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(m\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(m\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(m\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(m\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(m\\) {
    margin-inline: .625rem !important;
  }

  .m\\(m\\) {
    margin: 1.25rem !important;
  }

  .mt\\(m\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(m\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(m\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(m\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(m\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(m\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(m\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(m\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(m\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(m\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(m\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(m\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(m\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(m\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(m\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(m\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(m\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(m\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(m\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(m\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(m\\) {
    padding: 0 !important;
  }

  .pt0\\(m\\) {
    padding-top: 0 !important;
  }

  .pr0\\(m\\) {
    padding-right: 0 !important;
  }

  .pb0\\(m\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(m\\) {
    padding-left: 0 !important;
  }

  .pv0\\(m\\) {
    padding-block: 0 !important;
  }

  .ph0\\(m\\) {
    padding-inline: 0 !important;
  }

  .p--\\(m\\) {
    padding: .313rem !important;
  }

  .pt--\\(m\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(m\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(m\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(m\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(m\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(m\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(m\\) {
    padding: .625rem !important;
  }

  .pt-\\(m\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(m\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(m\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(m\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(m\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(m\\) {
    padding-inline: .625rem !important;
  }

  .p\\(m\\) {
    padding: 1.25rem !important;
  }

  .pt\\(m\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(m\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(m\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(m\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(m\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(m\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(m\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(m\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(m\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(m\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(m\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(m\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(m\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(m\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(m\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(m\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(m\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(m\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(m\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(m\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .m0\\(\\!s\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!s\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!s\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!s\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!s\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!s\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!s\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!s\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!s\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!s\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!s\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!s\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!s\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!s\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!s\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!s\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!s\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!s\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!s\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!s\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!s\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!s\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!s\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!s\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!s\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!s\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!s\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!s\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!s\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!s\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!s\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!s\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!s\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!s\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!s\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!s\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!s\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!s\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!s\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!s\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!s\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!s\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!s\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!s\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!s\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!s\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!s\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!s\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!s\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!s\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!s\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!s\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!s\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!s\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!s\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!s\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!s\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!s\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!s\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!s\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!s\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!s\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!s\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!s\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!s\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!s\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!s\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!s\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!s\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!s\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!s\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!s\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!s\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!s\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!s\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!s\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!s\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!s\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!s\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!s\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!s\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!s\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!s\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!s\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .m0\\(\\!l\\) {
    margin: 0 !important;
  }

  .mt0\\(\\!l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(\\!l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(\\!l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(\\!l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(\\!l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(\\!l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(\\!l\\) {
    margin: .313rem !important;
  }

  .mt--\\(\\!l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(\\!l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(\\!l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(\\!l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(\\!l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(\\!l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(\\!l\\) {
    margin: .625rem !important;
  }

  .mt-\\(\\!l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(\\!l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(\\!l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(\\!l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(\\!l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(\\!l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(\\!l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(\\!l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(\\!l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(\\!l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(\\!l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(\\!l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(\\!l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(\\!l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(\\!l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(\\!l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(\\!l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(\\!l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(\\!l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(\\!l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(\\!l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(\\!l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(\\!l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(\\!l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(\\!l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(\\!l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(\\!l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(\\!l\\) {
    padding: 0 !important;
  }

  .pt0\\(\\!l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(\\!l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(\\!l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(\\!l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(\\!l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(\\!l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(\\!l\\) {
    padding: .313rem !important;
  }

  .pt--\\(\\!l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(\\!l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(\\!l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(\\!l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(\\!l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(\\!l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(\\!l\\) {
    padding: .625rem !important;
  }

  .pt-\\(\\!l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(\\!l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(\\!l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(\\!l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(\\!l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(\\!l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(\\!l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(\\!l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(\\!l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(\\!l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(\\!l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(\\!l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(\\!l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(\\!l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(\\!l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(\\!l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(\\!l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(\\!l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(\\!l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(\\!l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(\\!l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(\\!l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(\\!l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(\\!l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(\\!l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(\\!l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(\\!l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .m0\\(l\\) {
    margin: 0 !important;
  }

  .mt0\\(l\\) {
    margin-top: 0 !important;
  }

  .mr0\\(l\\) {
    margin-right: 0 !important;
  }

  .mb0\\(l\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(l\\) {
    margin-left: 0 !important;
  }

  .mv0\\(l\\) {
    margin-block: 0 !important;
  }

  .mh0\\(l\\) {
    margin-inline: 0 !important;
  }

  .m--\\(l\\) {
    margin: .313rem !important;
  }

  .mt--\\(l\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(l\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(l\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(l\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(l\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(l\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(l\\) {
    margin: .625rem !important;
  }

  .mt-\\(l\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(l\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(l\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(l\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(l\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(l\\) {
    margin-inline: .625rem !important;
  }

  .m\\(l\\) {
    margin: 1.25rem !important;
  }

  .mt\\(l\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(l\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(l\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(l\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(l\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(l\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(l\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(l\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(l\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(l\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(l\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(l\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(l\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(l\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(l\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(l\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(l\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(l\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(l\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(l\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(l\\) {
    padding: 0 !important;
  }

  .pt0\\(l\\) {
    padding-top: 0 !important;
  }

  .pr0\\(l\\) {
    padding-right: 0 !important;
  }

  .pb0\\(l\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(l\\) {
    padding-left: 0 !important;
  }

  .pv0\\(l\\) {
    padding-block: 0 !important;
  }

  .ph0\\(l\\) {
    padding-inline: 0 !important;
  }

  .p--\\(l\\) {
    padding: .313rem !important;
  }

  .pt--\\(l\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(l\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(l\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(l\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(l\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(l\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(l\\) {
    padding: .625rem !important;
  }

  .pt-\\(l\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(l\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(l\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(l\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(l\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(l\\) {
    padding-inline: .625rem !important;
  }

  .p\\(l\\) {
    padding: 1.25rem !important;
  }

  .pt\\(l\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(l\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(l\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(l\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(l\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(l\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(l\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(l\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(l\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(l\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(l\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(l\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(l\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(l\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(l\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(l\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(l\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(l\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(l\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(l\\) {
    padding-inline: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .m0\\(xl\\) {
    margin: 0 !important;
  }

  .mt0\\(xl\\) {
    margin-top: 0 !important;
  }

  .mr0\\(xl\\) {
    margin-right: 0 !important;
  }

  .mb0\\(xl\\) {
    margin-bottom: 0 !important;
  }

  .ml0\\(xl\\) {
    margin-left: 0 !important;
  }

  .mv0\\(xl\\) {
    margin-block: 0 !important;
  }

  .mh0\\(xl\\) {
    margin-inline: 0 !important;
  }

  .m--\\(xl\\) {
    margin: .313rem !important;
  }

  .mt--\\(xl\\) {
    margin-top: .313rem !important;
  }

  .mr--\\(xl\\) {
    margin-right: .313rem !important;
  }

  .mb--\\(xl\\) {
    margin-bottom: .313rem !important;
  }

  .ml--\\(xl\\) {
    margin-left: .313rem !important;
  }

  .mv--\\(xl\\) {
    margin-block: .313rem !important;
  }

  .mh--\\(xl\\) {
    margin-inline: .313rem !important;
  }

  .m-\\(xl\\) {
    margin: .625rem !important;
  }

  .mt-\\(xl\\) {
    margin-top: .625rem !important;
  }

  .mr-\\(xl\\) {
    margin-right: .625rem !important;
  }

  .mb-\\(xl\\) {
    margin-bottom: .625rem !important;
  }

  .ml-\\(xl\\) {
    margin-left: .625rem !important;
  }

  .mv-\\(xl\\) {
    margin-block: .625rem !important;
  }

  .mh-\\(xl\\) {
    margin-inline: .625rem !important;
  }

  .m\\(xl\\) {
    margin: 1.25rem !important;
  }

  .mt\\(xl\\) {
    margin-top: 1.25rem !important;
  }

  .mr\\(xl\\) {
    margin-right: 1.25rem !important;
  }

  .mb\\(xl\\) {
    margin-bottom: 1.25rem !important;
  }

  .ml\\(xl\\) {
    margin-left: 1.25rem !important;
  }

  .mv\\(xl\\) {
    margin-block: 1.25rem !important;
  }

  .mh\\(xl\\) {
    margin-inline: 1.25rem !important;
  }

  .m\\+\\(xl\\) {
    margin: 2.5rem !important;
  }

  .mt\\+\\(xl\\) {
    margin-top: 2.5rem !important;
  }

  .mr\\+\\(xl\\) {
    margin-right: 2.5rem !important;
  }

  .mb\\+\\(xl\\) {
    margin-bottom: 2.5rem !important;
  }

  .ml\\+\\(xl\\) {
    margin-left: 2.5rem !important;
  }

  .mv\\+\\(xl\\) {
    margin-block: 2.5rem !important;
  }

  .mh\\+\\(xl\\) {
    margin-inline: 2.5rem !important;
  }

  .m\\+\\+\\(xl\\) {
    margin: 5rem !important;
  }

  .mt\\+\\+\\(xl\\) {
    margin-top: 5rem !important;
  }

  .mr\\+\\+\\(xl\\) {
    margin-right: 5rem !important;
  }

  .mb\\+\\+\\(xl\\) {
    margin-bottom: 5rem !important;
  }

  .ml\\+\\+\\(xl\\) {
    margin-left: 5rem !important;
  }

  .mv\\+\\+\\(xl\\) {
    margin-block: 5rem !important;
  }

  .mh\\+\\+\\(xl\\) {
    margin-inline: 5rem !important;
  }

  .p0\\(xl\\) {
    padding: 0 !important;
  }

  .pt0\\(xl\\) {
    padding-top: 0 !important;
  }

  .pr0\\(xl\\) {
    padding-right: 0 !important;
  }

  .pb0\\(xl\\) {
    padding-bottom: 0 !important;
  }

  .pl0\\(xl\\) {
    padding-left: 0 !important;
  }

  .pv0\\(xl\\) {
    padding-block: 0 !important;
  }

  .ph0\\(xl\\) {
    padding-inline: 0 !important;
  }

  .p--\\(xl\\) {
    padding: .313rem !important;
  }

  .pt--\\(xl\\) {
    padding-top: .313rem !important;
  }

  .pr--\\(xl\\) {
    padding-right: .313rem !important;
  }

  .pb--\\(xl\\) {
    padding-bottom: .313rem !important;
  }

  .pl--\\(xl\\) {
    padding-left: .313rem !important;
  }

  .pv--\\(xl\\) {
    padding-block: .313rem !important;
  }

  .ph--\\(xl\\) {
    padding-inline: .313rem !important;
  }

  .p-\\(xl\\) {
    padding: .625rem !important;
  }

  .pt-\\(xl\\) {
    padding-top: .625rem !important;
  }

  .pr-\\(xl\\) {
    padding-right: .625rem !important;
  }

  .pb-\\(xl\\) {
    padding-bottom: .625rem !important;
  }

  .pl-\\(xl\\) {
    padding-left: .625rem !important;
  }

  .pv-\\(xl\\) {
    padding-block: .625rem !important;
  }

  .ph-\\(xl\\) {
    padding-inline: .625rem !important;
  }

  .p\\(xl\\) {
    padding: 1.25rem !important;
  }

  .pt\\(xl\\) {
    padding-top: 1.25rem !important;
  }

  .pr\\(xl\\) {
    padding-right: 1.25rem !important;
  }

  .pb\\(xl\\) {
    padding-bottom: 1.25rem !important;
  }

  .pl\\(xl\\) {
    padding-left: 1.25rem !important;
  }

  .pv\\(xl\\) {
    padding-block: 1.25rem !important;
  }

  .ph\\(xl\\) {
    padding-inline: 1.25rem !important;
  }

  .p\\+\\(xl\\) {
    padding: 2.5rem !important;
  }

  .pt\\+\\(xl\\) {
    padding-top: 2.5rem !important;
  }

  .pr\\+\\(xl\\) {
    padding-right: 2.5rem !important;
  }

  .pb\\+\\(xl\\) {
    padding-bottom: 2.5rem !important;
  }

  .pl\\+\\(xl\\) {
    padding-left: 2.5rem !important;
  }

  .pv\\+\\(xl\\) {
    padding-block: 2.5rem !important;
  }

  .ph\\+\\(xl\\) {
    padding-inline: 2.5rem !important;
  }

  .p\\+\\+\\(xl\\) {
    padding: 5rem !important;
  }

  .pt\\+\\+\\(xl\\) {
    padding-top: 5rem !important;
  }

  .pr\\+\\+\\(xl\\) {
    padding-right: 5rem !important;
  }

  .pb\\+\\+\\(xl\\) {
    padding-bottom: 5rem !important;
  }

  .pl\\+\\+\\(xl\\) {
    padding-left: 5rem !important;
  }

  .pv\\+\\+\\(xl\\) {
    padding-block: 5rem !important;
  }

  .ph\\+\\+\\(xl\\) {
    padding-inline: 5rem !important;
  }
}

.u-gap0 {
  gap: 0 !important;
}

.u-gap-- {
  gap: .313rem !important;
}

.u-gap- {
  gap: .625rem !important;
}

.u-gap {
  gap: 1.25rem !important;
}

.u-gap\\+ {
  gap: 2.5rem !important;
}

.u-gap\\+\\+ {
  gap: 5rem !important;
}

@media screen and (width <= 46.9375em) {
  .u-gap0\\(s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em) and (width <= 74.9375em) {
  .u-gap0\\(m\\) {
    gap: 0 !important;
  }

  .u-gap--\\(m\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(m\\) {
    gap: .625rem !important;
  }

  .u-gap\\(m\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(m\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(m\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 47em), print {
  .u-gap0\\(\\!s\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!s\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!s\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!s\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!s\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!s\\) {
    gap: 5rem !important;
  }
}

@media screen and (width <= 74.9375em) {
  .u-gap0\\(\\!l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(\\!l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(\\!l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(\\!l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(\\!l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(\\!l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 75em), print {
  .u-gap0\\(l\\) {
    gap: 0 !important;
  }

  .u-gap--\\(l\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(l\\) {
    gap: .625rem !important;
  }

  .u-gap\\(l\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(l\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(l\\) {
    gap: 5rem !important;
  }
}

@media screen and (width >= 90.0625em) {
  .u-gap0\\(xl\\) {
    gap: 0 !important;
  }

  .u-gap--\\(xl\\) {
    gap: .313rem !important;
  }

  .u-gap-\\(xl\\) {
    gap: .625rem !important;
  }

  .u-gap\\(xl\\) {
    gap: 1.25rem !important;
  }

  .u-gap\\+\\(xl\\) {
    gap: 2.5rem !important;
  }

  .u-gap\\+\\+\\(xl\\) {
    gap: 5rem !important;
  }
}
`;


class $e4158c4999727c54$export$3b3567c5e4c840f extends (0, $baeea1393dcde116$export$3f2f9f5909897157) {
    constructor(){
        super();
        this.inputRef = (0, $c2866c8c0be843b6$export$7d1e3a5e95ceca43)();
        this.formRef = (0, $c2866c8c0be843b6$export$7d1e3a5e95ceca43)();
        this.geschwindigkeit = "16000";
        this.vertragslaufzeit = "24";
        this.ortsVorwahl = "040";
        this.telefonanschluss = "noFlatrate";
        this._counter = 0;
    }
    _increment(e) {
        this._counter++;
    }
    gotoComparison() {
        const serialized = new URLSearchParams(new FormData(this.formRef.value)).toString();
        const url = `/dsl-vergleich/vergleich/?${serialized}`;
        window.location.href = url;
    }
    render() {
        return (0, $bd6886d5707a45a8$export$c0bb0b647f701bb5)`
      <div>
        <form ${(0, $c2866c8c0be843b6$export$eff4d24c3ff7876e)(this.formRef)}>
          <div class="mb">
            <label for="ortsVorwahl"><strong>Ortsvorwahl</strong></label>
            <input type="text" id="ortsVorwahl" name="ortsVorwahl" .value="${this.ortsVorwahl}" placeholder="z.B. 040" />
          </div>
          <div class="mb">
            <label for="speed" @click=${this._increment}>
              <strong>Geschwindigkeit</strong>
            </label>
            <bc-tooltip data-trigger-style="info-icon"> Es werden nur Tarife mit der minimal gewünschten Geschwindigkeit angezeigt. </bc-tooltip>
            <select class="c-select" id="speed" name="Speed">
              <option value="6000">6 Mbit/s</option>
              <option selected value="16000">16 Mbit/s</option>
              <option value="50000">50 Mbit/s</option>
              <option value="100000">100 Mbit/s</option>
              <option value="250000">250 Mbit/s</option>
            </select>
          </div>
          <div class="mb">
            <label><strong>Vertragslaufzeit</strong></label>
            <bc-tooltip data-trigger-style="info-icon"> Es werden nur Tarife mit der maximal gewünschten Vertragslaufzeit angezeigt. Je kürzer die Vertragslaufzeit, desto höher ist Ihre Flexibilität. </bc-tooltip>
            <div class="layout layout--auto">
              <div class="layout__item">
                <input class="c-inputfields__input--radio" id="ContractPeriod_1" type="radio" name="ContractPeriod" value="1" />
                <label for="ContractPeriod_1" class="c-inputfields__label c-inputfields__label--tight">Max. 1 Monat</label>
              </div>
              <div class="layout__item">
                <input class="c-inputfields__input--radio" id="ContractPeriod_24" type="radio" checked name="ContractPeriod" value="24" />
                <label for="ContractPeriod_24" class="c-inputfields__label c-inputfields__label--tight">Max. 24 Monate</label>
              </div>
              <div class="layout__item">
                <input class="c-inputfields__input--radio" id="ContractPeriod_all" type="radio" name="ContractPeriod" value="-1" />
                <label for="ContractPeriod_all" class="c-inputfields__label c-inputfields__label--tight">Egal</label>
              </div>
            </div>
          </div>
          <div class="mb">
            <label><strong>Mit Telefonanschluss?</strong></label>
            <bc-tooltip data-trigger-style="info-icon"> Bitte wählen Sie aus, ob Sie einen Telefonanschluss wünschen. </bc-tooltip>
            <div class="layout layout--auto">
              <div class="layout__item">
                <input class="c-inputfields__input--radio" id="TelephonyFlatIncluded_noFlatrate" type="radio" checked name="TelephonyFlatIncluded" value="noFlatrate" />
                <label for="TelephonyFlatIncluded_noFlatrate" class="c-inputfields__label c-inputfields__label--tight">Ja</label>
              </div>

              <div class="layout__item">
                <input class="c-inputfields__input--radio" id="TelephonyFlatIncluded_noPhone" type="radio" name="TelephonyFlatIncluded" value="noPhone" />
                <label for="TelephonyFlatIncluded_noPhone" class="c-inputfields__label c-inputfields__label--tight">Nein</label>
              </div>
            </div>
          </div>

          <div>
            <div class="mb">
              <div class="mb--">
                <strong>Mit kostenloser Hardware</strong>
              </div>
              <bc-tooltip data-trigger-style="info-icon"> Hier werden nur Tarife mit einer kostenfreien Internet-Hardware angezeigt. </bc-tooltip>
              <div class="layout layout--auto">
                <div class="layout__item">
                  <input class="c-inputfields__input--radio" id="ProductsWithFreeHardware_True" type="radio" name="ProductsWithFreeHardware" value="true" />
                  <label for="ProductsWithFreeHardware_True" class="c-inputfields__label c-inputfields__label--tight">Ja</label>
                </div>

                <div class="layout__item">
                  <input class="c-inputfields__input--radio" id="ProductsWithFreeHardware_False" type="radio" checked name="ProductsWithFreeHardware" value="false" />
                  <label for="ProductsWithFreeHardware_False" class="c-inputfields__label c-inputfields__label--tight">Nein</label>
                </div>
              </div>
            </div>

            <div class="mb">
              <div class="mb--">
                <strong>Nur Angebote mit WLAN-Hardware</strong>
              </div>
              <bc-tooltip data-trigger-style="info-icon"> Hier werden nur Tarife mit einer optionalen WLAN-Hardware angezeigt. Die anfallenden Kosten werden mit dem monatlichen Effektivpreis verrechnet. </bc-tooltip>
              <div class="layout layout--auto">
                <div class="layout__item">
                  <input class="c-inputfields__input--radio" id="OnlyProductsWithWlanHardware_True" type="radio" name="OnlyProductsWithWlanHardware" value="true" />
                  <label for="OnlyProductsWithWlanHardware_True" class="c-inputfields__label c-inputfields__label--tight">Ja</label>
                </div>

                <div class="layout__item">
                  <input class="c-inputfields__input--radio" id="OnlyProductsWithWlanHardware_False" type="radio" checked name="OnlyProductsWithWlanHardware" value="false" />
                  <label for="OnlyProductsWithWlanHardware_False" class="c-inputfields__label c-inputfields__label--tight">Nein</label>
                </div>
              </div>
            </div>

            <div class="mb">
              <div class="mb--">
                <strong>Mit TV/Entertainment</strong>
              </div>
              <bc-tooltip data-trigger-style="info-icon"> Hier werden Ihnen Tarife mit Fernsehanschluss (DSL/Kabel) und andere TV-Pakete angezeigt (z.B. HD-Option, Receiver, Festplatte, Extra-Sender oder Online-Videotheken). </bc-tooltip>
              <div class="layout layout--auto">
                <div class="layout__item">
                  <input class="c-inputfields__input--radio" id="OnlyProductsWithTvHardware_True" type="radio" name="OnlyProductsWithTvHardware" value="true" />
                  <label for="OnlyProductsWithTvHardware_True" class="c-inputfields__label c-inputfields__label--tight">Ja</label>
                </div>

                <div class="layout__item">
                  <input class="c-inputfields__input--radio" id="OnlyProductsWithTvHardware_False" type="radio" checked name="OnlyProductsWithTvHardware" value="false" />
                  <label for="OnlyProductsWithTvHardware_False" class="c-inputfields__label c-inputfields__label--tight">Nein</label>
                </div>
              </div>
            </div>

            <div class="mb">
              <div class="mb--">
                <strong>Kundengruppe</strong>
              </div>
              <bc-tooltip data-trigger-style="info-icon"> Wählen Sie Neukunde, sofern aktuell kein Vertrag besteht oder die Restlaufzeit des derzeitigen Vertrages weniger als ein Monat beträgt. Wählen Sie Wechsler, wenn Sie momentan in einem Vertrag sind und dieser mehr als einen Monat Restlaufzeit hat. </bc-tooltip>
              <div class="layout layout--auto">
                <div class="layout__item">
                  <input class="c-inputfields__input--radio" id="ExistingCustomer_True" type="radio" checked name="ExistingCustomer" value="true" />
                  <label for="ExistingCustomer_True" class="c-inputfields__label c-inputfields__label--tight">Wechsler</label>
                </div>

                <div class="layout__item">
                  <input class="c-inputfields__input--radio" id="ExistingCustomer_False" type="radio" name="ExistingCustomer" value="false" />
                  <label for="ExistingCustomer_False" class="c-inputfields__label c-inputfields__label--tight">Neukunde</label>
                </div>
              </div>
            </div>

            <a class="c-button c-button--fullwidth" @click="${this.gotoComparison}">Vergleichen</a>
          </div>
          <div ?hidden=${!this.isLoading}>
            <bc-loading-icon></bc-loading-icon>
          </div>
        </form>
      </div>
    `;
    }
}
$e4158c4999727c54$export$3b3567c5e4c840f.properties = {
    postalCode: "",
    isLoading: false,
    _counter: {
        state: true
    },
    geschwindigkeit: {
        state: true
    },
    vertragslaufzeit: {
        state: true
    },
    ortsVorwahl: {
        state: true
    },
    telefonanschluss: {
        state: true
    }
};
$e4158c4999727c54$export$3b3567c5e4c840f.styles = [
    (0, $019808f85888b105$export$68cf25e5a1bc1124)
];
const $e4158c4999727c54$export$6cc089d6928af9c = ()=>{
    const elementName = "bc-dsl-form";
    if (!window.customElements.get(elementName)) window.customElements.define(elementName, $e4158c4999727c54$export$3b3567c5e4c840f);
};


const $68cce00e20779c30$var$navContainer = document.querySelector(".js-main-navbar");
const $68cce00e20779c30$export$240cd81d1fa164a8 = ()=>{
    $68cce00e20779c30$var$setScrollbarWidth();
    const navigationPopover = document.getElementById("navigation-popover");
    const navigationPopoverTrigger = document.getElementById("navigation-popover-trigger");
    if (!navigationPopover || !navigationPopoverTrigger) return;
    let navigationPopoverActive = navigationPopoverTrigger.offsetParent !== null;
    if (navigationPopoverActive) navigationPopover.setAttribute("popover", "");
    const navItems = $68cce00e20779c30$var$navContainer.querySelectorAll("a[popovertarget]");
    navItems.forEach((item)=>{
        let closeTimeout;
        const popoverTargetId = item.getAttribute("popovertarget");
        const popoverTarget = document.querySelector(`#${popoverTargetId}`);
        if (popoverTarget) {
            item.hidePopover = ()=>{
                popoverTarget.hidePopover();
            };
            item.addEventListener("click", (e)=>{
                if (navigationPopoverActive) {
                    e.preventDefault();
                    popoverTarget.style.setProperty("--anchor-top", `64px`);
                    setTimeout(popoverTarget.togglePopover(), 1);
                }
            });
            item.addEventListener("mouseover", (e)=>{
                if (!navigationPopoverActive) {
                    clearTimeout(closeTimeout);
                    $68cce00e20779c30$var$setOffset(item, popoverTarget);
                    popoverTarget.showPopover();
                }
            });
            item.addEventListener("mouseleave", (e)=>{
                if (!navigationPopoverActive) closeTimeout = setTimeout(item.hidePopover, 1);
            });
            popoverTarget.querySelector(".c-navigation-menu__sub").addEventListener("mouseover", (e)=>{
                if (!navigationPopoverActive) clearTimeout(closeTimeout);
            });
            popoverTarget.querySelector(".c-navigation-menu__sub").addEventListener("mouseleave", (e)=>{
                if (!navigationPopoverActive) closeTimeout = setTimeout(item.hidePopover, 1);
            });
            window.addEventListener("resize", ()=>{
                $68cce00e20779c30$var$setScrollbarWidth();
                navigationPopoverActive = navigationPopoverTrigger.offsetParent !== null;
                if (navigationPopoverActive) navigationPopover.setAttribute("popover", "");
                else navigationPopover.removeAttribute("popover");
            });
        }
    });
};
const $68cce00e20779c30$var$setScrollbarWidth = ()=>{
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
};
const $68cce00e20779c30$var$setOffset = (item, popoverTarget)=>{
    const itemPosition = item.getBoundingClientRect();
    const arrowPosition = itemPosition.left + itemPosition.width / 2;
    const { y: navbarBottom } = $68cce00e20779c30$var$navContainer.getBoundingClientRect();
    const topSpacing = navbarBottom + $68cce00e20779c30$var$navContainer.offsetHeight;
    popoverTarget.style.setProperty("--arrow-position-left", `${arrowPosition}px`);
    popoverTarget.style.setProperty("--popover-hover-trigger", popoverTarget.id);
    popoverTarget.style.setProperty("--anchor-top", `${topSpacing}px`);
};


const $7e4debd3f64ec3ac$export$f808344a2ba3e03 = ()=>{
    const filterPopover = document.getElementById("filter-popover");
    const filterPopoverTrigger = document.getElementById("filter-popover-trigger");
    if (!filterPopover || !filterPopoverTrigger) return;
    let filterPopoverActive = filterPopoverTrigger.offsetParent !== null;
    if (filterPopoverActive) filterPopover.setAttribute("popover", "");
    window.addEventListener("resize", ()=>{
        filterPopoverActive = filterPopoverTrigger.offsetParent !== null;
        if (filterPopoverActive) filterPopover.setAttribute("popover", "");
        else filterPopover.removeAttribute("popover");
    });
};


const $31b6f657dffad9ea$export$91db7bf3cf52d2ee = ()=>{
    const providerFilter = document.querySelector('.js-provider-filter');
    const providerList = document.querySelector('.js-provider-list');
    if (!providerFilter || !providerList) return;
    const providerItems = providerList.querySelectorAll('.js-provider-item');
    let delaySearch = null;
    if (!providerFilter || !providerList) return;
    providerFilter.focus();
    function filterProvider(filter) {
        clearTimeout(delaySearch);
        delaySearch = setTimeout(function() {
            processSearch(filter);
        }, 250);
    }
    function processSearch(filter) {
        var providerCount = 0;
        providerItems.forEach((provider)=>{
            var hideThis = provider.innerText.search(new RegExp(filter, 'i')) < 0;
            provider.toggleAttribute("hidden", hideThis);
            providerCount += hideThis ? 0 : 1;
        });
        document.querySelector('.js-number-of-providers').innerText = providerCount;
    }
    providerFilter.addEventListener("input", function() {
        filterProvider(this.value);
    });
};


const $fc3e7aca76592be4$export$6bd9755bd64780dc = ()=>{
    const contextElement = document.getElementById("content-source");
    if (contextElement) $fc3e7aca76592be4$var$wrapTablesInCMSContent(contextElement);
};
const $fc3e7aca76592be4$var$wrapTablesInCMSContent = (contextElement)=>{
    Array.from(contextElement.querySelectorAll("table")).forEach((table)=>{
        table.outerHTML = `<div class="o-scroll-wrapper">${table.outerHTML}</div>`;
    });
};




(0, $7a3728ce0eeb1492$export$a7bf4f2a9a5bdf95)();
(0, $4be2fd52edaf76ec$export$2dcf7e0dfd976c87)();
(0, $13264f5f318530c9$export$b226d6bf775a92f2)();
(0, $c0224998cf8b7c3f$export$324571b27622cdf8)();
(0, $b7e8a4ad65e86607$export$7934a1fe8ff0c156)();
(0, $cca191d6e1c32022$export$5b26f5125ff18a6b)();
(0, $e4158c4999727c54$export$6cc089d6928af9c)();

})();
//# sourceMappingURL=web-components.js.map
